import React, { useEffect, useMemo, useState } from "react";
import jsPDF from "jspdf";
import bataryaSirali from "./assets/batarya_sirali_seri_kart.png";
import bataryaParalel from "./assets/batarya_ust_uste_paralel_kart.png";
import bataryaInterlaced from "./assets/batarya_ic_ice_interlaced_kart.png";

const APP_USERS = [
  { username: "5330542", password: "uBghU7ZW", company: "A.T.C. Air Trade Centre Hav. Sist. San. Ve Tic. A.S." },
  { username: "6433829", password: "iMGT06QR", company: "AİRTEK MEKANİK MÜHENDİSLİK SANAYİ VE TİC LTD ŞTİ" },
  { username: "8323692", password: "9uW5KMxv", company: "Akplus Endüstriyel İklimlendirme A.Ş" },
  { username: "3190678", password: "RN57XgtF", company: "ALE Enerji A.Ş." },
  { username: "6435783", password: "T0rdbqHQ", company: "ALMİS GLOBAL INSAAT ANONIM SIRKETI" },
  { username: "5181752", password: "n9dc6RHF", company: "Alp Klima Sist. Ltd. Şti." },
  { username: "8321367", password: "vG9seQ3F", company: "ALTINOGLU LPG DAYANIKLI TUK MAL TIC VE SAN LTD STI" },
  { username: "4897594", password: "W57sj0d3", company: "ALTUNCU MÜHENDİSLİK SAN VE TİC LT.DŞTİ" },
  { username: "3149977", password: "rFWQna0k", company: "Analiz Group Teknoloji A.Ş." },
  { username: "7079979", password: "As5CQe9a", company: "ANIK ENERJI SAN VE TICARET LIMITED SIRKETI" },
  { username: "4896349", password: "6oqDMw2k", company: "Ankara Klima Havalandırma Isıtma Soğutma Mekanik Tesisat ve Elektrik Otomasyon Sistemleri San.TİC .LTD.ŞTİ." },
  { username: "1497898", password: "Lxu3xJD9", company: "Asya İklimlendirme Sist. San. Ve Tic. Ltd. Şti." },
  { username: "2465895", password: "o2RXG7AU", company: "Atmosfer Klima Mühendislik İnşaat Gıda Tekstil San. Tic. Ltd. Şti." },
  { username: "2211699", password: "5WhQQ7aP", company: "Balans Müh. Mek. Taah. Ve Proje San. Tic. Ltd. Şti." },
  { username: "7081470", password: "ZWtEof2P", company: "BHN iklimlendirme inş ith. Ihr. San ve Tic Ltd. Şti." },
  { username: "3360639", password: "xWrdvi8j", company: "BOREAS TEKNOLOJİ SANAYİ VE TİCARET A.Ş." },
  { username: "2350786", password: "2qvzYEh8", company: "Daf Teknoloji Sanayi ve Ticaret Limited Şirketi" },
  { username: "4939548", password: "cXeq7BG6", company: "DAPA TEKNOLOJİ SANAYİ VE TİCARET ANONİM ŞİRKETİ" },
  { username: "6470347", password: "z08FvGEz", company: "DERYA DIZAYN YAPI TASARIM MIMARLIK INSAAT DAYANIKLI TÜKETIM MALLARI SANAYI VE TICARET LTD.STI." },
  { username: "6441965", password: "b2LWt1xC", company: "DIHA MÜHENDISLIK IKLIMLENDIRME INSAAT OTOMOTIV ENERJI SANAYI TICARET LIMITED SIRKETI" },
  { username: "3405502", password: "57VMKgq6", company: "DMC Isıt. Soğ. Sist. San. Ve Tic. Ltd. Şti." },
  { username: "4779513", password: "0Pjt3WhM", company: "Doğan DTM San. Tic. Ltd. Şti." },
  { username: "4784679", password: "m6xFjELQ", company: "EFOR ISITMA VE SOĞUTMA MÜHENDİSLİK HİZMETLERİ TİCARET LİMİTED ŞİRKETİ" },
  { username: "3430300", password: "wUdgpE8G", company: "EGEMEN Elektrikli Ev Alet. Paz. A.Ş." },
  { username: "7088928", password: "msUkR6ME", company: "EKİP TERMO MÜHENDİSLİK SAN. TİC. A.Ş" },
  { username: "4977678", password: "BZ5QwyeJ", company: "EKODA DAYANIKLI TÜKETİM İNŞ. TUR VE SAN TİC. A.Ş." },
  { username: "2228602", password: "iWy4KgDd", company: "Enes Bilişim Elek. Oto. Müş. Tur. San. Ve Tic. Ltd. Şti." },
  { username: "4491249", password: "V0p7fkBj", company: "EREN MÜHENDİSLİK SOLAR VE MEKANİK ENERJİ SİSTEMLERİ" },
  { username: "2489324", password: "d9W3qVp5", company: "EŞLİK KLİMA SİSTEMLERİ SANAYİ VE TİCARET LİMİTED ŞİRKETİ" },
  { username: "5992318", password: "vzQNU4c7", company: "Evotherm Enerji Mühendislik LTD. ŞTİ." },
  { username: "4170681", password: "wPoEhaH3", company: "Exen Enerji ve Isı Teknolojileri San.Ve Tic.Ltd.Şti." },
  { username: "3880117", password: "Wcubbm1Z", company: "Hakan Altun İnş.San.Tic.Ltd.Şti." },
  { username: "2245029", password: "FtdhRkg5", company: "Halil İbrahim Bazır" },
  { username: "3182877", password: "4sHFnh4X", company: "Hevsel İklimlendirme" },
  { username: "7093097", password: "FGwcT3Th", company: "KADİR DAĞLI" },
  { username: "7091365", password: "Ad1qMeLd", company: "Karadayı DTM" },
  { username: "2263967", password: "o9iLmtCH", company: "Kethuda Müh. İnş. San. Ve Tic. Ltd. Şti." },
  { username: "1493128", password: "i8oz9Hdc", company: "KMK Isıtma Klima Sist. San. Ve Tic. Ltd. Şti." },
  { username: "3190706", password: "Y00vkYV7", company: "KOC PAZARLAMA IC DIS TIC. LTD.STI." },
  { username: "3147725", password: "1G3t5CWN", company: "Kurtuluş Mühendislik" },
  { username: "8356642", password: "hhf4AmPa", company: "Maviay Mühendislik" },
  { username: "4896748", password: "if7cX48n", company: "MEKANT MÜHENDİSLİK LTD.ŞTİ." },
  { username: "4349646", password: "d8BNtb11", company: "MERMERLER ULUSLARARASI TAŞIMACILIK TURİZM SANAYİ TİCARET LİMİTED ŞİRKETİ" },
  { username: "5968615", password: "AYwgga1Y", company: "Messe Elektronik Day. Tük. Mal San. Ve Tic. A.Ş." },
  { username: "2266264", password: "H83rcv6N", company: "Oba Gayrimenkul Değerleme ve Müh. Tic. Ltd. Şti." },
  { username: "5790863", password: "t319LNQp", company: "Özge Mühendislik İnş. Mlz. Otomativ San. ve Tic. Ltd. Şti." },
  { username: "4215097", password: "ynC1QxFQ", company: "RES Enerji Sistemleri A.Ş." },
  { username: "4755838", password: "6h6d3TAD", company: "S Plaza DTM İnş.Taah.San.ve Tic.A.Ş." },
  { username: "4169147", password: "Zhi6FzyV", company: "SAFİRNOVA MÜHENDİSLİK İKLİMLENDİRME İNŞ.TUR.SAN.VE TİC.LTD.ŞTİ" },
  { username: "2491358", password: "Qcn0ajGo", company: "Sambros İklimlendirme" },
  { username: "2219582", password: "P7y6by7V", company: "Sampro Klima ve Hav. Sist. San. Ve Tic. Ltd. Şti." },
  { username: "6499109", password: "x1aP7oKW", company: "SEMAC ENERJI SISTEMLERI LIMITED SIRKETI" },
  { username: "2465894", password: "Ao2aiDMH", company: "Seven Klima Isıtma Soğutma Havalandırma ve San.Tic.Ltd.Şti" },
  { username: "4199166", password: "zcreNF3R", company: "Sovo Mekanik Anonim Şirketi" },
  { username: "9339141", password: "DJ7w2gWM", company: "Suser Maks World Trading Co. Ltd." },
  { username: "3360638", password: "QmhqkE6e", company: "Teknosa İç ve Dış Ticaret A.Ş." },
  { username: "3889673", password: "w1KBw74L", company: "TOTAŞ ENERJİ KLİMA ISITMA SOĞ. SAN TİC LTD.ŞTİ." },
  { username: "3156846", password: "qht8rfnc", company: "Urla DTM" },
  { username: "4983441", password: "3vsiJThL", company: "ÜÇAY MÜHENDISLIK DOGAL GAZ MAKINE INSAAT BILISIM SANAYI VE TICARET A.S" },
  { username: "2498986", password: "mJn3X5wc", company: "Verde Mühendislik" },
  { username: "7093771", password: "Ld1w7u70", company: "FläktGroup Havalandırma Sanayi A.Ş" },
  { username: "yetkiliservis", password: "samsung1", company: "Yetkili Servis" },
];

const KW_PER_HP = 2.8;
const CAPACITY_CONTROL_METHOD = '"0-10V" Kapasite Kontrol';
const CAPACITY_CONTROL_WARNING_TEXT = `DİKKAT:

"0-10V" Kapasite Kontrol seçildiği için santral debisi, dış ünite seçim hesabında dikkate alınmamıştır.

Sahada devreye alma, santral otomasyonu ve DX kontrol ayarları "kapasite kontrol" senaryosuna uygun şekilde yapılmalıdır.`;
const CAPACITY_CONTROL_WARNING_TEXT_SINGLE_LINE = CAPACITY_CONTROL_WARNING_TEXT.replace(/\s*\n\s*/g, " ");
const STANDARD_HP_OPTIONS = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26];
const ECO_HP_OPTIONS = [4, 5, 6, 8, 10];

const STANDARD_MODEL_MAP = {
  8: ["AM080AXVAGH/EU"],
  10: ["AM100AXVAGH/EU"],
  12: ["AM120AXVAGH/EU"],
  14: ["AM140AXVAGH/EU"],
  16: ["AM160AXVAGH/EU"],
  18: ["AM180AXVAGH/EU"],
  20: ["AM200AXVAGH/EU"],
  22: ["AM220AXVAGH/EU"],
  24: ["AM240AXVAGH/EU"],
  26: ["AM260AXVAGH/EU"],
};

const ECO_MODEL_MAP = {
  4: ["AM040BXMDEH/EU", "AM040BXMDGR/EU"],
  5: ["AM050BXMDEH/EU", "AM050BXMDGR/EU"],
  6: ["AM060BXMDGR/EU"],
  8: ["AM080BXMWGH/EU"],
  10: ["AM100BXMWGH/EU"],
};

const formatNumber = (value, digits = 2) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return num.toLocaleString("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
};

const APPROVAL_TEXT = `Klima santrali uygulamalarında kullanılacak Samsung marka dış ünite, AHU Kit ve EEV ekipmanlarına ait tüm projelerde, sipariş süreci başlamadan önce ilgili teknik dokümanların, sistem tasarım bilgilerinin ve proje verilerinin Satış Portalı üzerinden eksiksiz şekilde Samsung’a iletilmesi ve resmi uygunluk/onay sürecinin tamamlanması zorunludur.

Samsung AHU Kontrol Raporu PDF çıktısı ve bu rapordaki uygunluk onayı alınmadan gerçekleştirilecek sipariş, uygulama ve devreye alma süreçlerinde oluşabilecek sistem performansı, ürün uyumluluğu ve garanti kapsamına ilişkin risk ve sorumluluklar iş ortağı/partner firmaya ait olacaktır. Bu nedenle, tüm iş ortaklarımızın ilgili kontrol ve onay prosedürünü eksiksiz şekilde tamamlaması gerekir.`;

const toNumber = (value) => {
  const normalized = String(value ?? "").trim().replace(",", ".");
  if (!normalized) return NaN;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : NaN;
};

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;

  for (let i = 0; i < bytes.byteLength; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }

  return window.btoa(binary);
};

const loadPdfFont = async (doc, url, vfsName, family, style) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Font yüklenemedi: ${url}`);
  }

  const buffer = await res.arrayBuffer();
  const base64 = arrayBufferToBase64(buffer);

  doc.addFileToVFS(vfsName, base64);
  doc.addFont(vfsName, family, style);
};

const setupPdfFonts = async (doc) => {
  try {
    await loadPdfFont(
      doc,
      "/fonts/SamsungSans-Regular.ttf",
      "SamsungSans-Regular.ttf",
      "SamsungSans",
      "normal"
    );

    await loadPdfFont(
      doc,
      "/fonts/SamsungSans-Bold.ttf",
      "SamsungSans-Bold.ttf",
      "SamsungSans",
      "bold"
    );

    doc.setFont("SamsungSans", "normal");
    return true;
  } catch (error) {
    console.error("SamsungSans yüklenemedi, Helvetica fallback kullanılıyor:", error);
    doc.setFont("helvetica", "normal");
    return false;
  }
};

const setPdfFont = (doc, fontOk, style = "normal") => {
  if (fontOk) {
    doc.setFont("SamsungSans", style);
  } else {
    doc.setFont("helvetica", style);
  }
};

const getModelNamesByModeAndHp = (mode, hp) => {
  const map = mode === "Eco" || mode === "DVM S Eco" ? ECO_MODEL_MAP : STANDARD_MODEL_MAP;
  return map[hp] || [];
};

const getSelectionBasis = ({ hasCapacity, hasAirflow, capacityHp, airflowHp, airflowMaxRequiredHp }) => {
  if (hasCapacity && hasAirflow) {
    const capacityDominant = capacityHp >= airflowMaxRequiredHp;
    return {
      label: capacityDominant ? "kW’a göre hesaplandı" : "Debiye göre hesaplandı",
      reason: `kW karşılığı ${formatNumber(capacityHp)} HP, debiye göre gereken ${formatNumber(
        airflowMaxRequiredHp
      )} HP. Büyük olan değer seçim için baz alınmıştır. Girilen debi, seçilen dış ünitenin izin verilen min/nom/max hava debisi aralığında ayrıca kontrol edilir.`,
    };
  }

  if (hasCapacity) {
    return {
      label: "kW’a göre hesaplandı",
      reason: `Sadece kW girildi. Seçim ${formatNumber(capacityHp)} HP kapasite ihtiyacına göre yapıldı.`,
    };
  }

  if (hasAirflow) {
    return {
      label: "Debiye göre hesaplandı",
      reason: `Kapasite girilmediği için seçim ${formatNumber(airflowMaxRequiredHp)} HP debi ihtiyacına göre yapıldı. Girilen debi, seçilen dış ünitenin izin verilen min/nom/max hava debisi aralığında ayrıca kontrol edilir.`,
    };
  }

  return {
    label: "-",
    reason: "Kapasite veya debi bilgisi girilmedi.",
  };
};

const buildStandardCombinations = () => {
  const combos = [];

  for (let i = 0; i < STANDARD_HP_OPTIONS.length; i += 1) {
    const a = STANDARD_HP_OPTIONS[i];
    combos.push([a]);

    for (let j = i; j < STANDARD_HP_OPTIONS.length; j += 1) {
      const b = STANDARD_HP_OPTIONS[j];
      if (a + b <= 40) combos.push([a, b]);

      for (let k = j; k < STANDARD_HP_OPTIONS.length; k += 1) {
        const c = STANDARD_HP_OPTIONS[k];
        if (a + b + c <= 40) combos.push([a, b, c]);
      }
    }
  }

  return combos;
};

const STANDARD_COMBINATIONS = buildStandardCombinations();

const getBalanceScore = (combo) => {
  if (!combo || combo.length === 0) return 999;
  return Math.max(...combo) - Math.min(...combo);
};

const buildComboLabel = (combo) => combo.map((hp) => `${hp} HP`).join(" + ");

const getEevQtyByHp = (hp, use2HpTolerance = false) => {
  const value = Number(hp) || 0;
  if (use2HpTolerance) {
    return Math.ceil(Math.max(value - 2, 0) / 10) || 0;
  }
  return Math.ceil(value / 10) || 0;
};

const hasEev2HpToleranceDiff = (hp) => {
  const value = Number(hp) || 0;
  return getEevQtyByHp(value, true) < getEevQtyByHp(value, false);
};

const MANUAL_ASYM_HP_PREFERENCE = [20, 22, 18, 24, 16, 26, 14, 12, 10, 8];

const getStandardSelectionTargetHp = (hp) => {
  const value = Number(hp) || 0;
  if (value <= 0) return 0;
  const base = Math.floor(value);
  const rounded = base % 2 === 0 ? base : base + 1;
  return Math.max(8, rounded);
};

const isStandardHpOption = (hp) => STANDARD_HP_OPTIONS.includes(Number(hp));

const canCompleteStandardUnits = (remainingHp, slots) => {
  const remaining = Number(remainingHp);
  if (!Number.isFinite(remaining)) return false;
  if (slots === 0) return remaining === 0;
  if (remaining < 0) return false;
  if (remaining < Math.min(...STANDARD_HP_OPTIONS) * slots) return false;
  if (remaining > Math.max(...STANDARD_HP_OPTIONS) * slots) return false;

  return STANDARD_HP_OPTIONS.some((hp) => canCompleteStandardUnits(remaining - hp, slots - 1));
};

const findStandardUnitCombo = (totalHp, unitCount, prefix = []) => {
  const total = Math.round(Number(totalHp) || 0);
  const count = Number(unitCount) || 0;
  if (total <= 0 || count <= 0) return null;

  const fixedPrefix = [];
  for (let i = 0; i < Math.min(prefix.length, count); i += 1) {
    const hp = Number(prefix[i]);
    if (!isStandardHpOption(hp)) return null;
    fixedPrefix.push(hp);
  }

  const fixedTotal = fixedPrefix.reduce((sum, hp) => sum + hp, 0);
  if (fixedTotal > total) return null;
  if (!canCompleteStandardUnits(total - fixedTotal, count - fixedPrefix.length)) return null;

  const walk = (combo) => {
    if (combo.length === count) {
      return combo.reduce((sum, hp) => sum + hp, 0) === total ? combo : null;
    }

    const currentTotal = combo.reduce((sum, hp) => sum + hp, 0);
    for (const hp of MANUAL_ASYM_HP_PREFERENCE) {
      const nextTotal = currentTotal + hp;
      const slotsLeft = count - combo.length - 1;
      if (canCompleteStandardUnits(total - nextTotal, slotsLeft)) {
        const result = walk([...combo, hp]);
        if (result) return result;
      }
    }

    return null;
  };

  return walk(fixedPrefix);
};

const getStandardUnitCountOptionsForTotal = (totalHp) => {
  const total = Math.round(Number(totalHp) || 0);
  const options = [];
  for (let count = 1; count <= 10; count += 1) {
    if (findStandardUnitCombo(total, count)) options.push(count);
  }
  return options;
};

const getMinStandardUnitCountForTotal = (totalHp) => getStandardUnitCountOptionsForTotal(totalHp)[0] || 0;

const getPreferredManualAsymUnitCount = (totalHp) => {
  const options = getStandardUnitCountOptionsForTotal(totalHp);
  return options.find((count) => count >= 2) || options[0] || 0;
};

const getSmallestStandardTotalWithUnitCountAtLeast = (minHp, minUnitCount = 2) => {
  const start = Math.max(8, Math.ceil(Number(minHp) || 0));
  for (let total = start; total <= 200; total += 1) {
    const options = getStandardUnitCountOptionsForTotal(total);
    if (options.some((count) => count >= minUnitCount)) return total;
  }
  return start;
};

const resolveManualAsymUnits = (totalHp, currentValues = [], preferredUnitCount = 0) => {
  const total = Math.round(Number(totalHp) || 0);
  const unitCount = preferredUnitCount || getPreferredManualAsymUnitCount(total);
  if (!unitCount) return [];

  const prefix = [];
  for (let i = 0; i < unitCount - 1; i += 1) {
    const hp = Number(currentValues[i]);
    if (!isStandardHpOption(hp)) break;
    prefix.push(hp);
  }

  return findStandardUnitCombo(total, unitCount, prefix) || findStandardUnitCombo(total, unitCount) || [];
};

const getManualUnitOptionsForIndex = (totalHp, unitCount, currentValues, index) => {
  if (index >= unitCount - 1) return [];
  const prefix = [];
  for (let i = 0; i < index; i += 1) {
    const hp = Number(currentValues[i]);
    if (!isStandardHpOption(hp)) return [];
    prefix.push(hp);
  }

  return STANDARD_HP_OPTIONS.filter((hp) => findStandardUnitCombo(totalHp, unitCount, [...prefix, hp]));
};

const packUnitsIntoCircuitGroups = (units) => {
  const groups = [];
  units.forEach((hp) => {
    const last = groups[groups.length - 1];
    const lastTotal = last ? last.reduce((sum, item) => sum + item, 0) : 0;
    if (!last || lastTotal + hp > 40) {
      groups.push([hp]);
    } else {
      last.push(hp);
    }
  });
  return groups;
};

const buildManualAsymmetricPlan = (totalRequiredHp, totalSelectedHp, currentValues, mode, preferredUnitCount = 0) => {
  const manualUnits = resolveManualAsymUnits(totalSelectedHp, currentValues, preferredUnitCount);
  if (manualUnits.length === 0) return null;

  const groups = packUnitsIntoCircuitGroups(manualUnits);
  const totalHp = manualUnits.reduce((sum, hp) => sum + hp, 0);
  const circuitCount = groups.length;

  return {
    circuitCount,
    perCircuitRequiredHp: circuitCount > 0 ? totalRequiredHp / circuitCount : totalRequiredHp,
    customCircuitGroups: groups,
    selectedPerCircuit: {
      units: manualUnits,
      totalHp,
      unitCount: manualUnits.length,
      oversize: totalHp - totalRequiredHp,
      balanceScore: 0,
      label: buildComboLabel(manualUnits),
      modelLabel: buildComboModelLabel(mode, manualUnits),
    },
    totalOutdoorUnitCount: manualUnits.length,
    totalOversize: totalHp - totalRequiredHp,
    totalSelectedHp: totalHp,
    totalSelectedKw: totalHp * KW_PER_HP,
    manualAsymmetric: true,
  };
};

const buildComboModelLabel = (mode, combo) =>
  combo
    .map((hp) => {
      const models = getModelNamesByModeAndHp(mode, hp);
      return `${hp} HP → ${models.join(" / ") || "-"}`;
    })
    .join(" | ");

const getEcoSelection = (requiredHp) => {
  const pickedHp = ECO_HP_OPTIONS.find((hp) => hp >= requiredHp);
  if (!pickedHp) return null;

  const units = [pickedHp];
  return {
    units,
    totalHp: pickedHp,
    unitCount: 1,
    oversize: pickedHp - requiredHp,
    balanceScore: 0,
    label: buildComboLabel(units),
    modelLabel: buildComboModelLabel("Eco", units),
  };
};

const getStandardCandidates = (requiredHp) => {
  const selectionTargetHp = getStandardSelectionTargetHp(requiredHp);
  const suitable = STANDARD_COMBINATIONS
    .filter((combo) => {
      const totalHp = combo.reduce((sum, hp) => sum + hp, 0);
      return totalHp >= selectionTargetHp && totalHp <= 40;
    })
    .map((combo) => {
      const totalHp = combo.reduce((sum, hp) => sum + hp, 0);
      const unitCount = combo.length;
      const oversize = totalHp - requiredHp;
      const balanceScore = getBalanceScore(combo);

      return {
        units: combo,
        totalHp,
        unitCount,
        oversize,
        balanceScore,
        label: buildComboLabel(combo),
        modelLabel: buildComboModelLabel("Standart", combo),
      };
    });

  if (suitable.length === 0) return [];

  const minUnitCount = Math.min(...suitable.map((item) => item.unitCount));

  return suitable
    .filter((item) => item.unitCount === minUnitCount)
    .sort((a, b) => {
      if (a.balanceScore !== b.balanceScore) return a.balanceScore - b.balanceScore;
      if (a.oversize !== b.oversize) return a.oversize - b.oversize;
      return a.totalHp - b.totalHp;
    });
};

const getCloseCapacityGlobalPlan = (totalRequiredHp) => {
  const options = STANDARD_HP_OPTIONS;
  const candidates = [];

  const walk = (startIndex, combo, targetLength) => {
    if (combo.length === targetLength) {
      const totalHp = combo.reduce((sum, hp) => sum + hp, 0);
      if (totalHp < totalRequiredHp) return;

      const balanceScore = getBalanceScore(combo);
      if (balanceScore <= 0 || balanceScore > 2) return;

      candidates.push({
        circuitCount: combo.length,
        perCircuitRequiredHp: totalRequiredHp / combo.length,
        customCircuitUnits: combo,
        selectedPerCircuit: {
          units: combo,
          totalHp,
          unitCount: combo.length,
          oversize: totalHp - totalRequiredHp,
          balanceScore,
          label: buildComboLabel(combo),
          modelLabel: buildComboModelLabel("Standart", combo),
        },
        totalOutdoorUnitCount: combo.length,
        totalOversize: totalHp - totalRequiredHp,
        totalSelectedHp: totalHp,
        totalSelectedKw: totalHp * KW_PER_HP,
        capacityBalanceWarning: true,
        balanceWarningHp: balanceScore,
      });
      return;
    }

    for (let i = startIndex; i < options.length; i += 1) {
      walk(i, [...combo, options[i]], targetLength);
    }
  };

  for (let length = 1; length <= 5; length += 1) {
    walk(0, [], length);
  }

  if (candidates.length === 0) return null;

  return candidates.sort((a, b) => {
    if (a.totalOutdoorUnitCount !== b.totalOutdoorUnitCount) {
      return a.totalOutdoorUnitCount - b.totalOutdoorUnitCount;
    }
    if (a.totalOversize !== b.totalOversize) return a.totalOversize - b.totalOversize;
    if (a.balanceWarningHp !== b.balanceWarningHp) return a.balanceWarningHp - b.balanceWarningHp;
    return a.totalSelectedHp - b.totalSelectedHp;
  })[0];
};

const getPerCircuitSelection = (mode, requiredHp) => {
  if (mode === "Eco") {
    const selection = getEcoSelection(requiredHp);
    return {
      selected: selection,
      alternatives: selection ? [selection] : [],
    };
  }

  const candidates = getStandardCandidates(requiredHp);
  return {
    selected: candidates[0] || null,
    alternatives: candidates.slice(0, 8),
  };
};

const evaluateCircuitPlan = (mode, totalRequiredHp, circuitCount) => {
  if (circuitCount < 1 || circuitCount > 5) return null;

  const perCircuitRequiredHp = totalRequiredHp / circuitCount;

  if (mode === "Eco") {
    if (perCircuitRequiredHp > 10) return null;
  } else {
    if (perCircuitRequiredHp > 40) return null;
  }

  const selection = getPerCircuitSelection(mode, perCircuitRequiredHp);
  if (!selection.selected) return null;

  const totalOutdoorUnitCount = selection.selected.unitCount * circuitCount;
  const totalOversize = selection.selected.oversize * circuitCount;

  return {
    circuitCount,
    perCircuitRequiredHp,
    selectedPerCircuit: selection.selected,
    alternativesPerCircuit: selection.alternatives,
    totalOutdoorUnitCount,
    totalOversize,
    totalSelectedHp: selection.selected.totalHp * circuitCount,
    totalSelectedKw: selection.selected.totalHp * KW_PER_HP * circuitCount,
  };
};

const evaluateCircuitPlanOptions = (mode, totalRequiredHp, circuitCount) => {
  if (circuitCount < 1 || circuitCount > 5) return [];

  const perCircuitRequiredHp = totalRequiredHp / circuitCount;

  if (mode === "Eco") {
    if (perCircuitRequiredHp > 10) return [];
  } else {
    if (perCircuitRequiredHp > 40) return [];
  }

  const selection = getPerCircuitSelection(mode, perCircuitRequiredHp);
  const alternatives = selection.alternatives?.length ? selection.alternatives : selection.selected ? [selection.selected] : [];

  return alternatives.map((selected) => ({
    circuitCount,
    perCircuitRequiredHp,
    selectedPerCircuit: selected,
    alternativesPerCircuit: alternatives,
    totalOutdoorUnitCount: selected.unitCount * circuitCount,
    totalOversize: selected.oversize * circuitCount,
    totalSelectedHp: selected.totalHp * circuitCount,
    totalSelectedKw: selected.totalHp * KW_PER_HP * circuitCount,
  }));
};

const getReportCreatorLabel = (user) => {
  if (!user?.username) return "-";
  return user.company || user.username;
};

const getStatusColor = (ok) => {
  if (ok === true) return { bg: "#dcfce7", border: "#86efac", text: "#166534", soft: "#f0fdf4" };
  if (ok === false) return { bg: "#fee2e2", border: "#fecaca", text: "#991b1b", soft: "#fef2f2" };
  if (ok === "warning") return { bg: "#fef3c7", border: "#facc15", text: "#92400e", soft: "#fffbeb" };
  return { bg: "#f8fafc", border: "#e2e8f0", text: "#334155", soft: "#f8fafc" };
};

function App() {
  const [ahuProjectName, setAhuProjectName] = useState("");
  const [ahuProjectCity, setAhuProjectCity] = useState("");
  const [ahuProjectDistrict, setAhuProjectDistrict] = useState("");
  const [ahuServiceName, setAhuServiceName] = useState("");
  const [ahuDate, setAhuDate] = useState("");
  const [ahuOutdoorMode, setAhuOutdoorMode] = useState("DVM S2");
  const [ahuAhuType, setAhuAhuType] = useState("%100 Taze Havalı");
  const [ahuControlMethod, setAhuControlMethod] = useState("Üfleme Sıcaklığı Kontrol");
  const [ahuCoolingCapacity, setAhuCoolingCapacity] = useState("");
  const [ahuHeatingCapacity, setAhuHeatingCapacity] = useState("");
  const [ahuAirflow, setAhuAirflow] = useState("");
  const [ahuEvapTemp, setAhuEvapTemp] = useState("");
  const [ahuSuperheat, setAhuSuperheat] = useState("");
  const [ahuSubcool, setAhuSubcool] = useState("");
  const [ahuCondTemp, setAhuCondTemp] = useState("");
  const [ahuPipeVolumeLt, setAhuPipeVolumeLt] = useState("");
  const [ahuEnteringAirTemp, setAhuEnteringAirTemp] = useState("");
  const [ahuPressureDrop, setAhuPressureDrop] = useState("");
  const [ahuAirVelocity, setAhuAirVelocity] = useState("");
  const [ahuCircuitCount, setAhuCircuitCount] = useState("Otomatik");
  const [ahuCardMountPlace, setAhuCardMountPlace] = useState("İç Ortam");
  const [batteryLayout, setBatteryLayout] = useState("interlaced");
  const [designPriority, setDesignPriority] = useState("minOutdoor");
  const [asymManualUnitValues, setAsymManualUnitValues] = useState([]);
  const [asymManualUnitCountOverride, setAsymManualUnitCountOverride] = useState("");
  const [eev2HpToleranceActive, setEev2HpToleranceActive] = useState(false);
  const [calculationSnapshot, setCalculationSnapshot] = useState(null);
  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginAccepted, setLoginAccepted] = useState(false);
  const [loggedUser, setLoggedUser] = useState(null);
  const [rulesInfoOpen, setRulesInfoOpen] = useState(false);
  const [approvalChecked, setApprovalChecked] = useState(false);
  const [approvalAccepted, setApprovalAccepted] = useState(false);

  const ahuCalc = useMemo(() => {
    const coolingKw = toNumber(ahuCoolingCapacity);
    const heatingKw = toNumber(ahuHeatingCapacity);
    const airflowM3h = toNumber(ahuAirflow);
    const evap = toNumber(ahuEvapTemp);
    const superheat = toNumber(ahuSuperheat);
    const subcool = toNumber(ahuSubcool);
    const cond = toNumber(ahuCondTemp);
    const pipeVolumeLt = toNumber(ahuPipeVolumeLt);
    const enteringAirTemp = toNumber(ahuEnteringAirTemp);
    const pressureDrop = toNumber(ahuPressureDrop);
    const airVelocity = toNumber(ahuAirVelocity);

    const coeff = 480;
    const isEcoMode = ahuOutdoorMode === "DVM S Eco" || ahuOutdoorMode === "Eco";
    const isCapacityControl = ahuControlMethod === CAPACITY_CONTROL_METHOD;
    const airflowRequired = !isCapacityControl;
    const hasCoolingCapacity = Number.isFinite(coolingKw) && coolingKw > 0;
    const hasHeatingCapacity = Number.isFinite(heatingKw) && heatingKw > 0;
    const hasCapacity = hasCoolingCapacity || hasHeatingCapacity;
    const hasAirflow = Number.isFinite(airflowM3h) && airflowM3h > 0;

    const capacityKw = hasCoolingCapacity && hasHeatingCapacity
      ? Math.max(coolingKw, heatingKw)
      : hasCoolingCapacity
      ? coolingKw
      : hasHeatingCapacity
      ? heatingKw
      : 0;

    const capacitySource =
      hasCoolingCapacity && hasHeatingCapacity
        ? coolingKw >= heatingKw
          ? "soğutma kapasitesine göre"
          : "ısıtma kapasitesine göre"
        : hasCoolingCapacity
        ? "soğutma kapasitesine göre"
        : hasHeatingCapacity
        ? "ısıtma kapasitesine göre"
        : "-";

    const pipeVolumeMinLt = hasCapacity ? capacityKw * 0.20 : 0;
    const pipeVolumeMaxLt = hasCapacity ? capacityKw * 0.23 : 0;
    const pipeVolumeOk =
      hasCapacity &&
      Number.isFinite(pipeVolumeLt) &&
      pipeVolumeLt >= pipeVolumeMinLt &&
      pipeVolumeLt <= pipeVolumeMaxLt;

    const capacityHp = hasCapacity ? capacityKw / KW_PER_HP : 0;
    const airflowHp = hasAirflow ? airflowM3h / coeff : 0;
    const airflowMaxRequiredHp = hasAirflow ? airflowM3h / 576 : 0;
    const useAirflowForSelection = hasAirflow && !isCapacityControl;
    const rawRequiredTotalHp =
      hasCapacity
        ? Math.max(capacityHp, useAirflowForSelection ? airflowMaxRequiredHp : 0)
        : useAirflowForSelection
        ? airflowMaxRequiredHp
        : 0;

    const enteringAirCapacityIncreaseRatio =
      Number.isFinite(enteringAirTemp) && enteringAirTemp < 10 && enteringAirTemp >= 5
        ? 0.10
        : Number.isFinite(enteringAirTemp) && enteringAirTemp >= 0 && enteringAirTemp <= 4
        ? 0.20
        : Number.isFinite(enteringAirTemp) && enteringAirTemp >= -5 && enteringAirTemp < 0
        ? 0.30
        : 0;

    const enteringAirCapacityIncreasePercent = enteringAirCapacityIncreaseRatio * 100;
    const requiredTotalHp = rawRequiredTotalHp * (1 + enteringAirCapacityIncreaseRatio);

    const resolvedCapacityKw = hasCapacity ? capacityKw : rawRequiredTotalHp * KW_PER_HP;
    const theoreticalAirflowM3h = requiredTotalHp * coeff;
    const selectionBasisRaw = getSelectionBasis({
      hasCapacity,
      hasAirflow: useAirflowForSelection,
      capacityHp,
      airflowHp,
      airflowMaxRequiredHp,
    });

    const enteringAirCapacityIncreaseNote =
      enteringAirCapacityIncreasePercent > 0
        ? ` Batarya giriş havası ${formatNumber(enteringAirTemp)} °C olduğu için dış ünite kapasitesi %${formatNumber(enteringAirCapacityIncreasePercent)} artırıldı.`
        : "";

    const selectionBasis = {
      ...selectionBasisRaw,
      reason:
        (hasCapacity && selectionBasisRaw.label.includes("kW")
          ? `${selectionBasisRaw.reason} Hesap ${capacitySource} yapılmıştır.`
          : selectionBasisRaw.reason) + enteringAirCapacityIncreaseNote,
    };

    const selectedLoadSource =
      hasCapacity && useAirflowForSelection && airflowMaxRequiredHp > capacityHp
        ? "Debiye göre hesaplandı"
        : hasCapacity
        ? `${capacitySource.replace("kapasitesine göre", "kapasitesine göre hesaplandı")}`
        : useAirflowForSelection
        ? "Debiye göre hesaplandı"
        : "-";

    const hasLoadInput = hasCapacity || useAirflowForSelection;

    const buildPlanMetrics = (plan) => {
      if (!plan?.selectedPerCircuit && !plan?.customCircuitUnits && !plan?.customCircuitGroups) return null;

      const isCustomCircuitGroupPlan = Array.isArray(plan.customCircuitGroups) && plan.customCircuitGroups.length > 0;
      const circuitCount = plan.circuitCount || (isCustomCircuitGroupPlan ? plan.customCircuitGroups.length : 1);
      const planTotalSelectedHp =
        plan.totalSelectedHp ||
        ((plan.selectedPerCircuit?.totalHp || 0) * circuitCount);
      const selectedMinAirflow = planTotalSelectedHp * 432;
      const selectedStdAirflow = planTotalSelectedHp * 480;
      const selectedMaxAirflow = planTotalSelectedHp * 576;

      const airflowOk = hasAirflow
        ? airflowM3h >= selectedMinAirflow && airflowM3h <= selectedMaxAirflow
        : !airflowRequired;

      let airflowReason = airflowRequired ? "Debi bilgisi girilmedi." : "\"0-10V\" Kapasite Kontrol modunda debi zorunlu değildir.";
      if (hasAirflow) {
        if (airflowOk) {
          airflowReason = `Debi uygun. Min ${formatNumber(selectedMinAirflow)} / Standart ${formatNumber(
            selectedStdAirflow
          )} / Max ${formatNumber(selectedMaxAirflow)} m³/h`;
          const range = selectedMaxAirflow - selectedMinAirflow;
          if (range > 0) {
            const distToMin = (airflowM3h - selectedMinAirflow) / range;
            const distToMax = (selectedMaxAirflow - airflowM3h) / range;
            if (distToMin < 0.05 || distToMax < 0.05) {
              airflowReason += " (Sınıra yakın)";
            }
          }
        } else {
          airflowReason = `Debi uygun değil. Min ${formatNumber(
            selectedMinAirflow
          )} / Standart ${formatNumber(selectedStdAirflow)} / Max ${formatNumber(
            selectedMaxAirflow
          )} m³/h, girilen ${formatNumber(airflowM3h)} m³/h`;
        }
      }

      const airflowBasis =
        hasAirflow && airflowOk
          ? [
              { key: "min", label: "Min aralığa göre", value: selectedMinAirflow },
              { key: "nom", label: "Nominal aralığa göre", value: selectedStdAirflow },
              { key: "max", label: "Max aralığa göre", value: selectedMaxAirflow },
            ].sort(
              (a, b) => Math.abs(airflowM3h - a.value) - Math.abs(airflowM3h - b.value)
            )[0]
          : null;

      const isCustomCircuitPlan = Array.isArray(plan.customCircuitUnits) && plan.customCircuitUnits.length > 0;

      const circuitModelGroups = isCustomCircuitGroupPlan
        ? plan.customCircuitGroups.map((units, circuitIndex) => {
            const totalHp = units.reduce((sum, hp) => sum + hp, 0);
            const eevQty = getEevQtyByHp(totalHp, eev2HpToleranceActive);
            return {
              circuitNo: circuitIndex + 1,
              units: units.map((hp, unitIndex) => ({
                unitNo: unitIndex + 1,
                hp,
                models: getModelNamesByModeAndHp(ahuOutdoorMode, hp),
              })),
              totalHp,
              totalKw: totalHp * KW_PER_HP,
              ahuKitModel: "MCM-D201N",
              ahuKitQty: 1,
              eevModel: "MXD-64K100E",
              eevQty,
            };
          })
        : isCustomCircuitPlan
        ? plan.customCircuitUnits.map((hp, circuitIndex) => {
            const eevQty = getEevQtyByHp(hp, eev2HpToleranceActive);
            return {
              circuitNo: circuitIndex + 1,
              units: [
                {
                  unitNo: 1,
                  hp,
                  models: getModelNamesByModeAndHp(ahuOutdoorMode, hp),
                },
              ],
              totalHp: hp,
              totalKw: hp * KW_PER_HP,
              ahuKitModel: "MCM-D201N",
              ahuKitQty: 1,
              eevModel: "MXD-64K100E",
              eevQty,
            };
          })
        : Array.from({ length: circuitCount }, (_, circuitIndex) => {
            const eevQty = getEevQtyByHp(plan.selectedPerCircuit?.totalHp || plan.perCircuitRequiredHp, eev2HpToleranceActive);
            return {
              circuitNo: circuitIndex + 1,
              units: plan.selectedPerCircuit.units.map((hp, unitIndex) => ({
                unitNo: unitIndex + 1,
                hp,
                models: getModelNamesByModeAndHp(ahuOutdoorMode, hp),
              })),
              totalHp: plan.selectedPerCircuit.totalHp,
              totalKw: plan.selectedPerCircuit.totalHp * KW_PER_HP,
              ahuKitModel: "MCM-D201N",
              ahuKitQty: 1,
              eevModel: "MXD-64K100E",
              eevQty,
            };
          });

      const totalEev = circuitModelGroups.reduce((sum, circuit) => sum + (circuit.eevQty || 0), 0);
      const eevPerCircuit = isCustomCircuitPlan ? "-" : getEevQtyByHp(plan.selectedPerCircuit?.totalHp || plan.perCircuitRequiredHp, eev2HpToleranceActive);
      const hasEev2HpToleranceCandidate = circuitModelGroups.some((circuit) => hasEev2HpToleranceDiff(circuit.totalHp));

      return {
        ...plan,
        selectedMinAirflow,
        selectedStdAirflow,
        selectedMaxAirflow,
        airflowOk,
        airflowReason,
        totalEev,
        eevPerCircuit,
        hasEev2HpToleranceCandidate,
        eev2HpToleranceActive,
        circuitModelGroups,
        airflowBasisKey: airflowBasis?.key || "",
        airflowBasisLabel: airflowBasis?.label || "",
        roundedUpHp: planTotalSelectedHp - requiredTotalHp,
        roundedUpKw: planTotalSelectedHp * KW_PER_HP - requiredTotalHp * KW_PER_HP,
        capacityBalanceWarning: Boolean(plan.capacityBalanceWarning),
        balanceWarningHp: plan.balanceWarningHp || plan.selectedPerCircuit?.balanceScore || 0,
      };
    };

    const rawPlans =
      !hasLoadInput
        ? []
        : isEcoMode
        ? [1, 2, 3, 4, 5].flatMap((count) => evaluateCircuitPlanOptions("Eco", requiredTotalHp, count))
        : [1, 2, 3, 4, 5].flatMap((count) => evaluateCircuitPlanOptions("Standart", requiredTotalHp, count));

    const candidatePlans = rawPlans
      .map((plan) => buildPlanMetrics(plan))
      .filter(Boolean)
      .sort((a, b) => {
        const aAirOk = a.airflowOk ? 1 : 0;
        const bAirOk = b.airflowOk ? 1 : 0;
        if (aAirOk !== bAirOk) return bAirOk - aAirOk;

        if (designPriority === "minCircuit") {
          if (a.circuitCount !== b.circuitCount) return a.circuitCount - b.circuitCount;
          if (a.totalOutdoorUnitCount !== b.totalOutdoorUnitCount) {
            return a.totalOutdoorUnitCount - b.totalOutdoorUnitCount;
          }
        } else {
          if (a.totalOutdoorUnitCount !== b.totalOutdoorUnitCount) {
            return a.totalOutdoorUnitCount - b.totalOutdoorUnitCount;
          }
          if (a.circuitCount !== b.circuitCount) return a.circuitCount - b.circuitCount;
        }

        if (a.totalOversize !== b.totalOversize) {
          return a.totalOversize - b.totalOversize;
        }
        if (a.selectedPerCircuit.balanceScore !== b.selectedPerCircuit.balanceScore) {
          return a.selectedPerCircuit.balanceScore - b.selectedPerCircuit.balanceScore;
        }
        return a.totalSelectedHp - b.totalSelectedHp;
      });

    const autoPlan = candidatePlans.find((item) => item.airflowOk) || candidatePlans[0] || null;

    const baseAsymTotalHp =
      !isEcoMode && hasLoadInput
        ? autoPlan?.totalSelectedHp || getStandardSelectionTargetHp(requiredTotalHp)
        : 0;
    const asymManualTotalHp =
      !isEcoMode && hasLoadInput
        ? getSmallestStandardTotalWithUnitCountAtLeast(baseAsymTotalHp, 2)
        : 0;
    const asymManualUnitCountOptions = getStandardUnitCountOptionsForTotal(asymManualTotalHp);
    const requestedAsymUnitCount = Number(asymManualUnitCountOverride) || 0;
    const asymManualUnitCount = asymManualUnitCountOptions.includes(requestedAsymUnitCount)
      ? requestedAsymUnitCount
      : getPreferredManualAsymUnitCount(asymManualTotalHp);
    const asymManualResolvedUnits =
      !isEcoMode && asymManualUnitCount > 0
        ? resolveManualAsymUnits(asymManualTotalHp, asymManualUnitValues, asymManualUnitCount)
        : [];
    const rawManualAsymmetricPlan =
      !isEcoMode && hasLoadInput && asymManualResolvedUnits.length > 0
        ? buildManualAsymmetricPlan(requiredTotalHp, asymManualTotalHp, asymManualUnitValues, "Standart", asymManualUnitCount)
        : null;
    const manualAsymmetricPlan = rawManualAsymmetricPlan ? buildPlanMetrics(rawManualAsymmetricPlan) : null;

    const capacityBalanceAlternative = manualAsymmetricPlan;

    let activePlan = null;
    if (designPriority === "closeCapacity" && manualAsymmetricPlan) {
      activePlan = manualAsymmetricPlan;
    } else if (ahuCircuitCount === "Otomatik") {
      activePlan = autoPlan;
    } else {
      const manualCount = parseInt(ahuCircuitCount, 10) || 1;
      activePlan = candidatePlans.find((item) => item.circuitCount === manualCount) || null;
    }

    const circuitCount =
      activePlan?.circuitCount ||
      (ahuCircuitCount === "Otomatik" ? 1 : Number(ahuCircuitCount) || 1);

    const perCircuitRequiredHp = hasLoadInput
      ? activePlan?.perCircuitRequiredHp || requiredTotalHp / circuitCount || 0
      : 0;

    const circuitFeasible =
      !hasLoadInput
        ? false
        : isEcoMode
        ? perCircuitRequiredHp <= 10
        : perCircuitRequiredHp <= 40;

    const requiredFieldRows = [
      { label: "Proje İsmi", value: ahuProjectName, ok: ahuProjectName.trim() !== "", rule: "Zorunlu alan" },
      { label: "Şehir", value: ahuProjectCity, ok: ahuProjectCity.trim() !== "", rule: "Zorunlu alan" },
      { label: "Santral Adı", value: ahuProjectDistrict, ok: ahuProjectDistrict.trim() !== "", rule: "Örn: KS1-KS2-HKS" },
      { label: "Samsung İş Ortağı Firma Bilgileri", value: ahuServiceName, ok: ahuServiceName.trim() !== "", rule: "Zorunlu alan" },
      { label: "Tarih", value: ahuDate, ok: ahuDate.trim() !== "", rule: "Zorunlu alan" },
      {
        label: "Santral Tipi Seçimi",
        value: ahuAhuType,
        ok: true,
        rule: "Santral tipi seçilmelidir",
      },
      {
        label: "Santral Kontrol Yöntemi",
        value: ahuControlMethod,
        ok: true,
        rule: isCapacityControl
          ? "\"0-10V\" Kapasite Kontrol seçildiğinde santral debisi seçim hesabında dikkate alınmaz"
          : "Kontrol yöntemi seçilmelidir",
      },
      {
        label: "DX Toplam Soğutma Kapasitesi",
        value: hasCoolingCapacity ? `${formatNumber(coolingKw)} kW` : "-",
        ok: hasCapacity,
        rule: "Soğutma veya ısıtma kapasitesinden en az biri girilmelidir",
      },
      {
        label: "DX Toplam Isıtma Kapasitesi",
        value: hasHeatingCapacity ? `${formatNumber(heatingKw)} kW` : "-",
        ok: hasCapacity,
        rule: "Soğutma veya ısıtma kapasitesinden en az biri girilmelidir",
      },
      {
        label: "Santral Debisi",
        value: hasAirflow ? `${formatNumber(airflowM3h)} m³/h` : isCapacityControl ? "Zorunlu değil" : "-",
        ok: isCapacityControl ? true : hasAirflow,
        rule: isCapacityControl ? "\"0-10V\" Kapasite Kontrol modunda debi zorunlu değildir" : "Pozitif m³/h girilmelidir",
      },
      {
        label: "AHU Kart Montaj Yeri",
        value: ahuCardMountPlace || "-",
        ok: Boolean(ahuCardMountPlace),
        rule: "AHU kit/kart montaj yeri seçilmelidir",
      },
    ];

    const technicalRows = [
      {
        label: "Evaporasyon Sıcaklığı",
        value: Number.isFinite(evap) ? `${formatNumber(evap)} °C` : "-",
        ok: Number.isFinite(evap) ? evap >= 5 && evap <= 15 : false,
        rule: "5 – 15 °C",
      },
      {
        label: "Superheat",
        value: Number.isFinite(superheat) ? `${formatNumber(superheat)} °C` : "-",
        ok: Number.isFinite(superheat) ? superheat >= 1 && superheat <= 2 : false,
        rule: "1 – 2 °C",
      },
      {
        label: "Subcool",
        value: Number.isFinite(subcool) ? `${formatNumber(subcool)} °C` : "-",
        ok: Number.isFinite(subcool) ? subcool >= 5 && subcool <= 15 : false,
        rule: "5 – 15 °C",
      },
      {
        label: "Kondenzasyon Sıcaklığı",
        value: Number.isFinite(cond) ? `${formatNumber(cond)} °C` : "-",
        ok: Number.isFinite(cond) ? cond >= 35 && cond <= 55 : false,
        rule: "35 – 55 °C",
      },
      {
        label: "Batarya İç Hacmi",
        value: Number.isFinite(pipeVolumeLt) ? `${formatNumber(pipeVolumeLt)} L` : "-",
        ok: pipeVolumeOk,
        rule: hasCapacity
          ? `Samsung standart aralığı: ${formatNumber(pipeVolumeMinLt)} – ${formatNumber(pipeVolumeMaxLt)} L\nHesap: yüksek olan kW × 0,20 / 0,23`
          : "Önce soğutma veya ısıtma kapasitesi girilmelidir",
      },
      {
        label: "Batarya Giriş Havası Sıcaklığı",
        value: Number.isFinite(enteringAirTemp) ? `${formatNumber(enteringAirTemp)} °C` : "-",
        ok: Number.isFinite(enteringAirTemp)
          ? enteringAirTemp >= -5 && enteringAirTemp <= 32
            ? true
            : enteringAirTemp > 32 && enteringAirTemp <= 36
            ? "warning"
            : false
          : false,
        rule:
          Number.isFinite(enteringAirTemp) && enteringAirTemp > 32 && enteringAirTemp <= 36
            ? "32 – 36 °C arası uyarılı uygun. Samsung Türkiye Servis Departmanı ile iletişime geçiniz."
            : "-5 – 32 °C uygun / 32 – 36 °C uyarılı uygun",
      },
      {
        label: "R410A Basınç Kaybı",
        value: Number.isFinite(pressureDrop) ? `${formatNumber(pressureDrop)} kPa` : "-",
        ok: Number.isFinite(pressureDrop) ? pressureDrop >= 7 && pressureDrop <= 50 : false,
        rule: "7 – 50 kPa",
      },
      {
        label: "Hava Hızı",
        value: Number.isFinite(airVelocity) ? `${formatNumber(airVelocity)} m/s` : "-",
        ok: Number.isFinite(airVelocity) ? airVelocity < 2.51 : false,
        rule: "≤ 2,5 m/s",
      },
    ];

    const selectionRows = [
      {
        label: "Hesaplanan Dış Ünite HP",
        value: requiredTotalHp > 0 ? `${formatNumber(requiredTotalHp)} HP` : "-",
        ok: requiredTotalHp > 0,
        rule: `Baz alınan değer: ${selectedLoadSource}. Kural: max(kW/2,8, debi/576)`,
      },
      {
        label: "Hesaplanan Dış Ünite kW",
        value: activePlan ? `${formatNumber(activePlan.totalSelectedKw)} kW` : "-",
        ok: Boolean(activePlan?.selectedPerCircuit),
        rule: `${formatNumber(activePlan?.totalSelectedHp || 0)} HP × ${String(KW_PER_HP).replace(".", ",")} kW/HP`,
      },
      {
        label: "Hesaplanan Santral Debisi",
        value: `${formatNumber(theoreticalAirflowM3h)} m³/h`,
        ok: requiredTotalHp > 0,
        rule: "Seçim HP × 480 nominal debi karşılığı",
      },
      ...(enteringAirCapacityIncreasePercent > 0
        ? [
            {
              label: "Giriş Havası Kapasite Artırımı",
              value: `%${formatNumber(enteringAirCapacityIncreasePercent)} artırıldı`,
              ok: "warning",
              rule: `Batarya giriş havası ${formatNumber(enteringAirTemp)} °C olduğu için dış ünite kapasitesi artırıldı. Artırım sonrası uygun dış ünite modeli yukarı yuvarlanarak seçilir.`,
            },
          ]
        : []),
      {
        label: "Devre / Kapasite Sınırı",
        value: hasLoadInput
          ? `${formatNumber(requiredTotalHp)} HP ihtiyaç / ${formatNumber(
              (ahuCircuitCount === "Otomatik"
                ? isEcoMode
                  ? 10
                  : 200
                : (Number(ahuCircuitCount) || 1) * (isEcoMode ? 10 : 40))
            )} HP izin verilen üst sınır`
          : "-",
        ok:
          hasLoadInput
            ? requiredTotalHp <=
              (ahuCircuitCount === "Otomatik"
                ? isEcoMode
                  ? 10
                  : 200
                : (Number(ahuCircuitCount) || 1) * (isEcoMode ? 10 : 40))
            : false,
        rule:
          ahuCircuitCount === "Otomatik"
            ? isEcoMode
              ? "DVM S Eco otomatik seçimde max 1 devre × 10 HP = 10 HP."
              : "DVM S2 otomatik seçimde max 5 devre × 40 HP = 200 HP. Bu sınır aşılırsa santral bölünmeli veya özel onay alınmalıdır."
            : `${ahuCircuitCount} devre × ${isEcoMode ? 10 : 40} HP/devre sınırı.`,
      },
      {
        label: "Dış Ünite Seçimi",
        value: activePlan ? `${formatNumber(activePlan.totalSelectedHp)} HP / ${formatNumber(activePlan.totalSelectedKw)} kW` : "-",
        ok: Boolean(activePlan?.selectedPerCircuit),
        rule: isEcoMode ? "DVM S Eco: devre başı max 10 HP" : "DVM S2: devre başı max 40 HP",
      },
      {
        label: "Santral Debisi Kontrolü",
        value: hasAirflow ? `${formatNumber(airflowM3h)} m³/h` : isCapacityControl ? "Zorunlu değil" : "-",
        ok: activePlan ? activePlan.airflowOk : false,
        rule: activePlan
          ? hasAirflow
            ? `Min ${formatNumber(activePlan.selectedMinAirflow)}\nStandart ${formatNumber(activePlan.selectedStdAirflow)}\nMax ${formatNumber(activePlan.selectedMaxAirflow)} m³/h${
                activePlan.airflowBasisLabel ? `\nDebi konumu: ${activePlan.airflowBasisLabel}` : ""
              }`
            : "\"0-10V\" Kapasite Kontrol modunda debi girilmeden hesap yapılabilir"
          : "Seçim bekleniyor",
      },
      {
        label: "Seçim Modu",
        value: ahuOutdoorMode,
        ok: true,
        rule: isEcoMode ? "DVM S Eco tek cihaz/devre" : "DVM S2 kombinasyon",
      },
      {
        label: "Batarya Yerleşimi",
        value:
          batteryLayout === "serial"
            ? "Sıralı / Seri"
            : batteryLayout === "parallel"
            ? "Üst Üste / Paralel"
            : "İç İçe / Interlaced",
        ok: batteryLayout !== "serial",
        rule: "Sıralı / seri yerleşim önerilmez; paralel veya interlaced tercih edilmelidir",
      },
      {
        label: "Toplam EEV",
        value: activePlan ? `${activePlan.totalEev} adet` : "-",
        ok: Boolean(activePlan),
        rule: "EEV kuralı: standart hesapta her 10 HP için 1 EEV yukarı yuvarlanır. 2 HP EEV Toleransı seçilirse 10 HP üzeri +2 HP sınırına kadar aynı EEV adedi kullanılabilir; kapasite ve dış ünite hesabı değişmez.",
      },
      ...(activePlan?.hasEev2HpToleranceCandidate && eev2HpToleranceActive
        ? [
            {
              label: "2 HP EEV Toleransı",
              value: "EEV adedi toleranslı hesaplandı",
              ok: "warning",
              rule: "Standart EEV hesabı korunur; tolerans seçildiğinde 10 HP üzeri +2 HP sınırına kadar aynı EEV adedi kullanılabilir. Örnek: 12 HP için 1 EEV, 22 HP için 2 EEV, 32 HP için 3 EEV uygulanır. Kapasite ve dış ünite hesabında başka değişiklik yapılmaz.",
            },
          ]
        : []),
      ...(isCapacityControl
        ? [
            {
              label: CAPACITY_CONTROL_METHOD,
              value: "Debi dış ünite seçim kriterlerinde dikkate alınmadı",
              ok: "warning",
              rule: CAPACITY_CONTROL_WARNING_TEXT,
            },
          ]
        : []),
    ];

    const validationRows = [...requiredFieldRows, ...technicalRows, ...selectionRows];

    const invalidRows = validationRows.filter((row) => row.ok === false);
    const hasValidPlan = Boolean(activePlan?.selectedPerCircuit) && circuitFeasible;
    const allOk = hasValidPlan && invalidRows.length === 0;

    let systemReason = "";
    if (!hasCapacity || (airflowRequired && !hasAirflow)) {
      const missing = [];
      if (!hasCapacity) missing.push("DX soğutma veya ısıtma kapasitesi");
      if (airflowRequired && !hasAirflow) missing.push("Santral Debisi");
      systemReason = `Eksik zorunlu alanlar: ${missing.join(", ")}.`;
    } else if (!circuitFeasible) {
      const maxSystemHp =
        ahuCircuitCount === "Otomatik"
          ? isEcoMode
            ? 10
            : 200
          : (Number(ahuCircuitCount) || 1) * (isEcoMode ? 10 : 40);

      systemReason =
        requiredTotalHp > maxSystemHp
          ? `Seçim yapılamıyor: ${formatNumber(requiredTotalHp)} HP ihtiyaç var, izin verilen üst sınır ${formatNumber(maxSystemHp)} HP. ${
              isEcoMode
                ? "DVM S Eco sınırı aşılıyor."
                : "DVM S2 için maksimum 5 devre × 40 HP = 200 HP sınırı aşılıyor. Santral debisi düşürülmeli, santral bölünmeli veya özel onay alınmalıdır."
            }`
          : isEcoMode
          ? `DVM S Eco seçiminde devre başı ${formatNumber(perCircuitRequiredHp)} HP. Sınır 10 HP.`
          : `DVM S2 seçiminde devre başı ${formatNumber(perCircuitRequiredHp)} HP. Sınır 40 HP.`;
    } else if (!activePlan?.selectedPerCircuit) {
      systemReason = "Bu girişler için uygun dış ünite seçimi bulunamadı.";
    } else if (invalidRows.length > 0) {
      systemReason = `Kontrol dışı / eksik değerler: ${invalidRows
        .slice(0, 4)
        .map((row) => `${row.label} (${row.rule})`)
        .join(", ")}${invalidRows.length > 4 ? "..." : ""}`;
    } else if (validationRows.some((row) => row.ok === "warning")) {
      systemReason = "Uyarılı uygun: Devam etmeden önce ilgili uyarı notlarını kontrol ediniz.";
    } else {
      systemReason = "Tüm temel seçim ve kontrol kuralları sağlandı.";
    }

    const alternatives = candidatePlans
      .filter((item) => item.airflowOk)
      .slice(0, 5)
      .map((item, index) => ({
        id: `${item.circuitCount}-${item.selectedPerCircuit?.label || index}`,
        rank: index + 1,
        isRecommended:
          autoPlan &&
          item.circuitCount === autoPlan.circuitCount &&
          item.selectedPerCircuit?.label === autoPlan.selectedPerCircuit?.label,
        circuitCount: item.circuitCount,
        totalHp: item.totalSelectedHp,
        totalKw: item.totalSelectedKw,
        eevTotal: item.totalEev,
        oversize: item.totalOversize,
        roundedUpHp: item.roundedUpHp,
        roundedUpKw: item.roundedUpKw,
        airflowReason: item.airflowReason,
        modelGroups: item.circuitModelGroups || [],
      }));

    return {
      hasCoolingCapacity,
      hasHeatingCapacity,
      coolingKw,
      heatingKw,
      capacityKw,
      capacitySource,
      pipeVolumeLt,
      pipeVolumeMinLt,
      pipeVolumeMaxLt,
      pipeVolumeOk,
      selectedLoadSource,
      designPriority,
      designPriorityLabel:
        designPriority === "minCircuit"
          ? "1 - En Az Devre Sayısı"
          : designPriority === "closeCapacity"
          ? "3 - Asimetrik Devre Tasarımı"
          : "2 - En Az Dış Ünite Sayısı",
      isEcoMode,
      isCapacityControl,
      airflowRequired,
      hasCapacity,
      hasAirflow,
      resolvedCapacityKw,
      theoreticalAirflowM3h,
      capacityHp,
      airflowHp,
      airflowMaxRequiredHp,
      rawRequiredTotalHp,
      requiredTotalHp,
      enteringAirCapacityIncreasePercent,
      enteringAirCapacityIncreaseRatio,
      selectionBasis,
      autoPlan,
      activePlan,
      circuitCount,
      perCircuitRequiredHp,
      totalSelectedHp: activePlan?.totalSelectedHp || 0,
      totalSelectedKw: activePlan?.totalSelectedKw || 0,
      selectedMinAirflow: activePlan?.selectedMinAirflow || 0,
      selectedStdAirflow: activePlan?.selectedStdAirflow || 0,
      selectedMaxAirflow: activePlan?.selectedMaxAirflow || 0,
      airflowBasisKey: activePlan?.airflowBasisKey || "",
      airflowBasisLabel: activePlan?.airflowBasisLabel || "",
      totalEev: activePlan?.totalEev || 0,
      eevPerCircuit: activePlan?.eevPerCircuit || 0,
      hasEev2HpToleranceCandidate: Boolean(activePlan?.hasEev2HpToleranceCandidate),
      eev2HpToleranceActive,
      circuitModelGroups: activePlan?.circuitModelGroups || [],
      validationRows,
      invalidRows,
      allOk,
      alternatives,
      capacityBalanceAlternative,
      capacityBalanceActive: false,
      asymManualTotalHp,
      asymManualUnitCount,
      asymManualUnitCountOptions,
      asymManualResolvedUnits,
      circuitFeasible,
      systemReason,
      airflowReason: activePlan?.airflowReason || "Seçim bekleniyor.",
      roundedUpHp: activePlan?.roundedUpHp || 0,
      roundedUpKw: activePlan?.roundedUpKw || 0,
    };
  }, [
    ahuProjectName,
    ahuProjectCity,
    ahuProjectDistrict,
    ahuServiceName,
    ahuDate,
    ahuAirflow,
    ahuCircuitCount,
    ahuCondTemp,
    ahuPipeVolumeLt,
    ahuCoolingCapacity,
    ahuHeatingCapacity,
    ahuAhuType,
    ahuControlMethod,
    ahuEvapTemp,
    ahuOutdoorMode,
    ahuSubcool,
    ahuSuperheat,
    ahuEnteringAirTemp,
    ahuPressureDrop,
    ahuAirVelocity,
    batteryLayout,
    designPriority,
    asymManualUnitValues,
    asymManualUnitCountOverride,
    eev2HpToleranceActive,
  ]);

  const inputStyle = {
    width: "100%",
    padding: "13px 14px",
    borderRadius: 14,
    border: "1px solid #d1d5db",
    background: "#fff",
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
  };

  const labelStyle = {
    display: "flex",
    alignItems: "flex-end",
    fontWeight: 800,
    color: "#111827",
    marginBottom: 7,
    fontSize: 13,
    minHeight: 32,
    lineHeight: 1.15,
  };

  const cardStyle = {
    width: "100%",
    boxSizing: "border-box",
    background: "#fff",
    borderRadius: 22,
    boxShadow: "0 18px 50px rgba(15,23,42,0.08)",
    border: "1px solid rgba(148,163,184,0.20)",
  };

  const sectionTitleStyle = {
    margin: 0,
    fontSize: 18,
    color: "#111827",
    letterSpacing: "-0.02em",
  };

  const renderInput = (label, value, onChange, props = {}) => (
    <label style={{ display: "block" }}>
      <span style={labelStyle}>{label}</span>
      <input
        style={inputStyle}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        {...props}
      />
    </label>
  );

  const renderMetric = (title, value, note, ok = null) => {
    const colors = getStatusColor(ok);
    return (
      <div
        style={{
          borderRadius: 16,
          padding: "14px 14px",
          background: colors.soft,
          border: `1px solid ${colors.border}`,
          minHeight: 76,
        }}
      >
        <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>{title}</div>
        <div style={{ marginTop: 5, color: "#0f172a", fontWeight: 900, fontSize: 21 }}>
          {value}
        </div>
        {note ? (
          <div style={{ marginTop: 4, color: "#64748b", fontSize: 12, fontWeight: 600 }}>
            {note}
          </div>
        ) : null}
      </div>
    );
  };

  const renderValidationCard = (row) => {
    const colors = getStatusColor(row.ok);
    const ruleLines = String(row.rule || "").split("\\n").filter(Boolean);

    return (
      <div
        key={row.label}
        style={{
          borderRadius: 14,
          background: colors.soft,
          border: `1px solid ${colors.border}`,
          padding: "12px 13px",
        }}
      >
        <div style={{ fontWeight: 900, color: "#111827", fontSize: 13 }}>{row.label}</div>
        <div style={{ marginTop: 4, color: colors.text, fontWeight: 900, fontSize: 15 }}>
          {row.value}
        </div>
        {(row.ok === false || row.ok === "warning") && ruleLines.length > 0 ? (
          <div style={{ marginTop: 6, color: "#64748b", fontSize: 11.5, fontWeight: 700, lineHeight: 1.35 }}>
            {ruleLines.map((line, idx) => (
              <div key={idx}>{line}</div>
            ))}
          </div>
        ) : null}
      </div>
    );
  };


  const displayedCalc = calculationSnapshot;
  const canShowCalculation = Boolean(displayedCalc);
  const liveCalc = ahuCalc;
  const calc = displayedCalc || liveCalc;
  const alternativeButtonsEnabled = ahuCircuitCount === "Otomatik";
  const asymmetricButtonEnabled = canShowCalculation && !calc.isEcoMode && calc.totalSelectedHp > 0;
  const capacityBalanceButtonEnabled = asymmetricButtonEnabled;
  const displayValue = (value) => (canShowCalculation ? value : "-");
  const displayNote = (value, waiting = "Hesaplama bekleniyor") => (canShowCalculation ? value : waiting);

  const batteryLayouts = [
    { id: "serial", image: bataryaSirali, title: "Sıralı (Seri)", badge: "ÖNERİLMEZ", border: "#fca5a5", bg: "#fff7f7", text: "#991b1b", note: "Seri yerleşim önerilmez. Interlaced veya paralel düzen tercih edilmelidir." },
    { id: "parallel", image: bataryaParalel, title: "Üst Üste (Paralel)", badge: "KABUL EDİLEBİLİR", border: "#facc15", bg: "#fffbeb", text: "#92400e", note: "Doğru hava dağılımı ve batarya balansı sağlanırsa kullanılabilir." },
    { id: "interlaced", image: bataryaInterlaced, title: "İç İçe / Interlaced", badge: "ÖNERİLEN", border: "#86efac", bg: "#f0fdf4", text: "#166534", note: "Devreler iç içe geçirilir. Hava ve yük dağılımı daha dengeli olur." },
  ];

  const selectedBatteryLayout = batteryLayouts.find((item) => item.id === batteryLayout) || batteryLayouts[2];

  const getAccessoryLines = (calcData = calc) => {
    const ahuKitQty = Math.max(1, calcData?.circuitCount || 1);
    const base = [
      "PT1000 3 kablolu direnç tipi sensör — 1 Adet (piyasa temini)",
    ];

    const needsCurrentSensor =
      ahuControlMethod === "Üfleme Sıcaklığı Kontrol" || ahuControlMethod === "Her İkisi de";

    if (needsCurrentSensor) {
      base.push("4~20mA akım tipi sensör — 1 Adet (piyasa temini)");
    }

    base.push(`7 Telli Input Soket — ${ahuKitQty} Adet`);
    base.push(`4 Telli Output Soket — ${ahuKitQty} Adet`);
    base.push("Fark Basınç Anahtarı — 1 Adet");
    base.push(
      ahuCardMountPlace === "Dış Ortam"
        ? "IP68 Pano — 1 Adet"
        : "IP67 Pano — 1 Adet"
    );

    return base;
  };

  const getRemoteControllerLine = () => "Samsung Kablolu Kumanda — 1 Adet";


  useEffect(() => {
    if (loggedUser?.username && !ahuServiceName.trim()) {
      setAhuServiceName(getReportCreatorLabel(loggedUser));
    }
  }, [loggedUser, ahuServiceName]);

  useEffect(() => {
    const allowedForFreshAir = ["Üfleme Sıcaklığı Kontrol", CAPACITY_CONTROL_METHOD];
    if (ahuAhuType === "%100 Taze Havalı" && !allowedForFreshAir.includes(ahuControlMethod)) {
      setAhuControlMethod("Üfleme Sıcaklığı Kontrol");
    }
  }, [ahuAhuType, ahuControlMethod]);

  useEffect(() => {
    if (calculationSnapshot) {
      setCalculationSnapshot(ahuCalc);
    }
    // Sadece tasarım alternatifi değiştiğinde mevcut hesap sonucunu aynı girişlerle yeniler.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [designPriority, asymManualUnitValues, asymManualUnitCountOverride, eev2HpToleranceActive]);

  useEffect(() => {
    if (calculationSnapshot) {
      setCalculationSnapshot(null);
    }
    if (designPriority === "closeCapacity") {
      setDesignPriority("minOutdoor");
    }
    if (asymManualUnitValues.length > 0) {
      setAsymManualUnitValues([]);
    }
    if (asymManualUnitCountOverride) {
      setAsymManualUnitCountOverride("");
    }
    // Girişlerden herhangi biri değişirse eski sonuç geçersiz olur; tekrar Hesapla gerekir.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ahuProjectName,
    ahuProjectCity,
    ahuProjectDistrict,
    ahuServiceName,
    ahuDate,
    ahuOutdoorMode,
    ahuAhuType,
    ahuControlMethod,
    ahuCoolingCapacity,
    ahuHeatingCapacity,
    ahuAirflow,
    ahuEvapTemp,
    ahuSuperheat,
    ahuSubcool,
    ahuCondTemp,
    ahuPipeVolumeLt,
    ahuEnteringAirTemp,
    ahuPressureDrop,
    ahuAirVelocity,
    ahuCircuitCount,
    ahuCardMountPlace,
    batteryLayout,
  ]);

  const generateAhuPDF = async () => {
    try {
      const pdfCalc = calculationSnapshot || ahuCalc;
      const doc = new jsPDF("p", "mm", "a4");
      const fontOk = await setupPdfFonts(doc);

      const pageW = 210;
      const pageH = 297;
      const margin = 12;
      const contentW = pageW - margin * 2;
      let y = 20;

      const setFont = (style = "normal", size = 9, color = [15, 23, 42]) => {
        setPdfFont(doc, fontOk, style);
        doc.setFontSize(size);
        doc.setTextColor(...color);
      };

      const setHeader = () => {
        doc.setFillColor(5, 5, 5);
        doc.rect(0, 0, pageW, 15, "F");
        setFont("bold", 10, [255, 255, 255]);
        doc.text("SAMSUNG", margin, 9.5);
        const pdfHeaderTitle = `${ahuProjectName || "Proje"}${ahuProjectDistrict ? ` - ${ahuProjectDistrict}` : ""}`;
        doc.text(pdfHeaderTitle, pageW / 2, 9.5, { align: "center" });
        setFont("normal", 7.5, [203, 213, 225]);
        doc.text("Klima Sistemleri", pageW - margin, 9.5, { align: "right" });
        doc.setTextColor(15, 23, 42);
      };

      const ensureSpace = (needed = 30) => {
        if (y + needed > pageH - 14) {
          doc.addPage();
          setHeader();
          y = 24;
        }
      };

      const roundedBox = (x, boxY, w, h, fill, stroke) => {
        doc.setFillColor(...fill);
        doc.setDrawColor(...stroke);
        doc.roundedRect(x, boxY, w, h, 4, 4, "FD");
      };

      const writeLines = (lines, x, startY, w, opts = {}) => {
        const lineH = opts.lineH || 4.8;
        const size = opts.size || 9.4;
        const baseStyle = opts.style || "normal";
        const baseColor = opts.color || [15, 23, 42];
        let yy = startY;

        lines.forEach((line) => {
          const item =
            typeof line === "object" && line !== null
              ? line
              : { text: String(line || "-") };

          const text = String(item.text || "-");
          const color = item.color || baseColor;
          const style = item.style || baseStyle;
          const itemSize = item.size || size;

          setFont(style, itemSize, color);
          const split = doc.splitTextToSize(text, w);
          doc.text(split, x, yy);
          yy += split.length * (item.lineH || lineH);
        });

        return yy;
      };

      const section = (title, lines, options = {}) => {
        const fill = options.fill || [248, 250, 252];
        const stroke = options.stroke || [226, 232, 240];
        const titleColor = options.titleColor || [15, 23, 42];
        const lineH = options.lineH || 4.3;
        const size = options.size || 8.1;

        const wrappedCount = lines.reduce((sum, line) => {
          const item =
            typeof line === "object" && line !== null
              ? line
              : { text: String(line || "-") };
          const split = doc.splitTextToSize(String(item.text || "-"), contentW - 10);
          return sum + split.length;
        }, 0);
        const h = Math.max(options.minH || 26, 20 + wrappedCount * lineH);

        ensureSpace(h + 8);
        roundedBox(margin, y, contentW, h, fill, stroke);
        setFont("bold", 10.5, titleColor);
        doc.text(title, margin + 5, y + 8);
        writeLines(lines, margin + 5, y + 16, contentW - 10, { lineH, size });
        y += h + 8;
      };

      const twoColumnSection = (leftTitle, leftLines, rightTitle, rightLines) => {
        const gap = 6;
        const colW = (contentW - gap) / 2;
        const lineH = 4.2;
        const leftCount = leftLines.reduce((sum, line) => sum + doc.splitTextToSize(String(line || "-"), colW - 10).length, 0);
        const rightCount = rightLines.reduce((sum, line) => sum + doc.splitTextToSize(String(line || "-"), colW - 10).length, 0);
        const h = Math.max(54, 16 + Math.max(leftCount, rightCount) * lineH);

        ensureSpace(h + 8);
        roundedBox(margin, y, colW, h, [240, 253, 244], [134, 239, 172]);
        roundedBox(margin + colW + gap, y, colW, h, [239, 246, 255], [147, 197, 253]);

        setFont("bold", 10.5, [22, 101, 52]);
        doc.text(leftTitle, margin + 5, y + 8);
        writeLines(leftLines, margin + 5, y + 16, colW - 10, { lineH, size: 7.9 });

        setFont("bold", 10.5, [30, 64, 175]);
        doc.text(rightTitle, margin + colW + gap + 5, y + 8);
        writeLines(rightLines, margin + colW + gap + 5, y + 16, colW - 10, { lineH, size: 7.9 });
        y += h + 8;
      };

      const statusOk = pdfCalc.allOk;
      const statusFill = statusOk ? [220, 252, 231] : [254, 226, 226];
      const statusStroke = statusOk ? [134, 239, 172] : [252, 165, 165];
      const statusColor = statusOk ? [22, 101, 52] : [153, 27, 27];

      setHeader();

      setFont("bold", 17, [15, 23, 42]);
      doc.text("AHU Onay Raporu", margin, y);
      setFont("normal", 8.5, [100, 116, 139]);
      doc.text("Girilen değerler, hesaplanan seçim ve kontrol sonucu özetlenmiştir.", margin, y + 7);
      y += 17;

      roundedBox(margin, y, contentW, 16, statusFill, statusStroke);
      setFont("bold", 12.5, statusColor);
      doc.text(statusOk ? "SAMSUNG STANDARTLARINA UYGUNDUR" : "SAMSUNG STANDARTLARINA UYGUN DEĞİLDİR", pageW / 2, y + 10.5, {
        align: "center",
      });
      y += 25;

      section("Onay Beyanı", [
        "İş ortağı/partner firma, Samsung AHU Kontrol Raporu ve resmi uygunluk/onay süreci tamamlanmadan sipariş, uygulama ve devreye alma yapılması durumunda oluşabilecek risk ve sorumlulukların kendisine ait olduğunu kabul eder.",
        `Onay Durumu: ${approvalAccepted ? "Onaylandı" : "Onaylanmadı"}`,
      ], {
        fill: approvalAccepted ? [240, 253, 244] : [254, 242, 242],
        stroke: approvalAccepted ? [134, 239, 172] : [252, 165, 165],
        titleColor: approvalAccepted ? [22, 101, 52] : [153, 27, 27],
        minH: 34,
        size: 8.2,
      });

      section("Proje ve Santral Bilgileri", [
        `Proje: ${ahuProjectName || "-"}`,
        `Şehir: ${ahuProjectCity || "-"}    Santral Adı: ${ahuProjectDistrict || "-"}`,
        `Samsung İş Ortağı Firma: ${ahuServiceName || "-"}`,
        `Tarih: ${ahuDate || "-"}`,
        `Raporu Oluşturan: ${getReportCreatorLabel(loggedUser)}`,
        `Santral Tipi: ${ahuAhuType || "-"}`,
        `Santral Kontrol Yöntemi: ${ahuControlMethod || "-"}`,
        `AHU Kart Montaj Yeri: ${ahuCardMountPlace || "-"}`,
      ], { minH: 50 });

      section("Girilen Kapasite ve Teknik Değerler", [
        `Dış Ünite Seçimi: ${ahuOutdoorMode || "-"}`,
        `DX Toplam Soğutma Kapasitesi: ${ahuCoolingCapacity || "-"} kW`,
        `DX Toplam Isıtma Kapasitesi: ${ahuHeatingCapacity || "-"} kW`,
        `Santral Debisi: ${ahuAirflow || (pdfCalc.isCapacityControl ? "Zorunlu değil" : "-")} m³/h`,
        `DX Devre Sayısı: ${ahuCircuitCount === "Otomatik" ? `Otomatik (${pdfCalc.circuitCount})` : pdfCalc.circuitCount}`,
        `Evaporasyon: ${ahuEvapTemp || "-"} °C    Superheat: ${ahuSuperheat || "-"} °C    Subcool: ${ahuSubcool || "-"} °C`,
        `Kondenzasyon: ${ahuCondTemp || "-"} °C    Batarya İç Hacmi: ${ahuPipeVolumeLt || "-"} L`,
        `Batarya Giriş Havası: ${ahuEnteringAirTemp || "-"} °C    R410A Basınç Kaybı: ${ahuPressureDrop || "-"} kPa    Hava Hızı: ${ahuAirVelocity || "-"} m/s`,
        `Batarya Yerleşimi: ${selectedBatteryLayout.title} (${selectedBatteryLayout.badge})`,
      ], { minH: 62 });

      if (pdfCalc.isCapacityControl) {
        section("DİKKAT - Kapasite Kontrol Uyarısı", [
          {
            text:
              CAPACITY_CONTROL_WARNING_TEXT,
            style: "bold",
            color: [154, 52, 18],
            size: 10,
          },
        ], {
          fill: [255, 247, 237],
          stroke: [253, 186, 116],
          titleColor: [154, 52, 18],
          minH: 34,
          size: 9.6,
          lineH: 5.2,
        });
      }

      const resultLines = [
        `Hesaplanan Dış Ünite HP: ${formatNumber(pdfCalc.requiredTotalHp)} HP`,
        ...(pdfCalc.enteringAirCapacityIncreasePercent > 0
          ? [
              `Giriş Havası Kapasite Artırımı: %${formatNumber(
                pdfCalc.enteringAirCapacityIncreasePercent
              )} artırıldı. Ham ihtiyaç: ${formatNumber(pdfCalc.rawRequiredTotalHp)} HP.`,
            ]
          : []),
        `Hesaplanan Dış Ünite kW: ${formatNumber(pdfCalc.totalSelectedKw || pdfCalc.resolvedCapacityKw)} kW`,
        `Tasarım Alternatifi: ${pdfCalc.designPriorityLabel || (designPriority === "minCircuit" ? "1 - En Az Devre Sayısı" : "2 - En Az Dış Ünite Sayısı")}`,
        `Baz alınan kriter: ${pdfCalc.selectedLoadSource || pdfCalc.selectionBasis.label}`,
        pdfCalc.isCapacityControl ? `Seçim HP kuralı: kW/2,8 ("0-10V" Kapasite Kontrol nedeniyle santral debisi dış ünite seçim hesabında dikkate alınmadı)` : `Seçim HP kuralı: max(kW/2,8, debi/576)`,
        ...(pdfCalc.hasAirflow && !pdfCalc.isCapacityControl
          ? [`Debiye göre gereken HP: ${formatNumber(pdfCalc.airflowMaxRequiredHp)} HP`]
          : []),
        `Seçim açıklaması: ${pdfCalc.selectionBasis.reason}`,
        `Hesaplanan Santral Debisi: ${formatNumber(pdfCalc.theoreticalAirflowM3h)} m³/h`,
        `Seçilen Dış Ünite: ${formatNumber(pdfCalc.totalSelectedHp)} HP / ${formatNumber(pdfCalc.totalSelectedKw)} kW`,
        `Batarya İç Hacmi: ${formatNumber(pdfCalc.pipeVolumeLt)} L / Samsung standart aralığı: ${formatNumber(pdfCalc.pipeVolumeMinLt)} – ${formatNumber(pdfCalc.pipeVolumeMaxLt)} L`,
        ...(pdfCalc.eev2HpToleranceActive
          ? ["2 HP EEV Toleransı: EEV adedi +2 HP toleransına göre hesaplanmıştır. Kapasite ve dış ünite hesabında değişiklik yapılmamıştır."]
          : []),
        `İzin Verilen Santral Hava Debisi:`,
        `  Min: ${formatNumber(pdfCalc.selectedMinAirflow)} m³/h`,
        `  Nom: ${formatNumber(pdfCalc.selectedStdAirflow)} m³/h`,
        `  Max: ${formatNumber(pdfCalc.selectedMaxAirflow)} m³/h`,
        ...(pdfCalc.airflowBasisLabel ? [`Debi konumu: ${pdfCalc.airflowBasisLabel}`] : []),
        `Toplam EEV: ${pdfCalc.totalEev} adet`,
        `Ürün Bazlı Yuvarlama: +${formatNumber(pdfCalc.roundedUpHp)} HP / +${formatNumber(pdfCalc.roundedUpKw)} kW`,
      ];

      const deviceLines =
        pdfCalc.circuitModelGroups.length > 0
          ? [
              ...pdfCalc.circuitModelGroups.flatMap((circuit) => [
                `Devre ${circuit.circuitNo}: ${formatNumber(circuit.totalHp)} HP / ${formatNumber(circuit.totalKw)} kW`,
                ...circuit.units.map((unit) => `${unit.unitNo}. Ünite: ${unit.hp} HP — ${unit.models.join(" / ") || "-"}`),
                `AHU Kart: ${circuit.ahuKitModel || "MCM-D201N"} — ${circuit.ahuKitQty || 1} Adet`,
                `EEV: ${circuit.eevModel || "MXD-64K100E"} — ${circuit.eevQty || pdfCalc.eevPerCircuit || "-"} Adet`,
                "",
              ]),
              "Tasarım Ekipmanı:",
              `• ${getRemoteControllerLine()}`,
            ]
          : ["Seçim bekleniyor."];

      twoColumnSection("Sonuçlar", resultLines, "Seçilen Cihaz / Devre / Kit", deviceLines);

      const enteringAirWarningPdf =
        Number.isFinite(toNumber(ahuEnteringAirTemp)) &&
        toNumber(ahuEnteringAirTemp) > 32 &&
        toNumber(ahuEnteringAirTemp) <= 36;
      const warningRows = pdfCalc.validationRows.filter((row) => {
        if (row.ok !== "warning") return false;
        if (row.label === CAPACITY_CONTROL_METHOD) return false;
        if (enteringAirWarningPdf && row.label === "Batarya Giriş Havası Sıcaklığı") return false;
        return true;
      });
      const hasPdfWarningRows = warningRows.length > 0 || enteringAirWarningPdf;
      const issueLines =
        pdfCalc.invalidRows.length > 0 || warningRows.length > 0 || enteringAirWarningPdf
          ? [
              ...(enteringAirWarningPdf
                ? [
                    {
                      text: `ÖNEMLİ UYARI: Batarya giriş havası ${formatNumber(
                        toNumber(ahuEnteringAirTemp)
                      )} °C değerindedir. 32-36 °C aralığı uyarılı uygun kabul edilir. Devam etmeden önce Samsung Türkiye Servis Departmanı ile iletişime geçiniz.`,
                      color: [185, 28, 28],
                      style: "bold",
                      size: 10.4,
                    },
                    { text: "", size: 5 },
                  ]
                : []),
              ...pdfCalc.invalidRows.flatMap((row) => {
                const ruleParts = String(row.rule || "")
                  .split("\n")
                  .filter(Boolean);

                return [
                  {
                    text: `• ${row.label}: ${row.value || "-"}`,
                    color: [185, 28, 28],
                    style: "bold",
                    size: 9.8,
                  },
                  ...ruleParts.map((rule) => ({
                    text: `  ${rule}`,
                    color: [185, 28, 28],
                    size: 9.4,
                  })),
                ];
              }),
              ...warningRows.flatMap((row) => {
                const ruleParts = String(row.rule || "")
                  .split("\n")
                  .filter(Boolean);

                return [
                  {
                    text: `• UYARI - ${row.label}: ${row.value || "-"}`,
                    color: [194, 65, 12],
                    style: "bold",
                    size: 9.8,
                  },
                  ...ruleParts.map((rule) => ({
                    text: `  ${rule}`,
                    color: [194, 65, 12],
                    size: 9.4,
                  })),
                ];
              }),
              { text: "", size: 5 },
              { text: "Gerekli Ekipman Listesi:", style: "bold", size: 9.8 },
              ...getAccessoryLines(pdfCalc).map((line) => ({ text: `• ${line}` })),
            ]
          : [
              "• Samsung standartlarına uygundur.",
              "",
              { text: "Gerekli Ekipman Listesi:", style: "bold", size: 9.8 },
              ...getAccessoryLines(pdfCalc).map((line) => `• ${line}`),
            ];

      section(statusOk && !hasPdfWarningRows ? "Samsung Standartları Uygunluk Notu" : "Samsung Standartlarına Uygun Olmayan Maddeler", issueLines, {
        fill: statusOk && !hasPdfWarningRows ? [240, 253, 244] : [255, 247, 237],
        stroke: statusOk && !hasPdfWarningRows ? [134, 239, 172] : [253, 186, 116],
        titleColor: statusOk && !hasPdfWarningRows ? [22, 101, 52] : [154, 52, 18],
        minH: 56,
        size: 9.6,
        lineH: 5.5,
      });

      const safePdfName = `${ahuProjectName || "Proje"}_${ahuProjectDistrict || "Santral"}`
        .replace(/[\\/:*?"<>|]+/g, "-")
        .replace(/\s+/g, "_")
        .slice(0, 90);

      doc.save(`${safePdfName}.pdf`);
    } catch (error) {
      console.error("AHU PDF HATASI:", error);
      alert("AHU PDF oluşturulurken hata oluştu.");
    }
  };

  if (!loginAccepted) {
    const handleLoginSubmit = (event) => {
      event.preventDefault();
      setLoginError("");

      const matchedUser = APP_USERS.find(
        (user) => user.username === loginUsername.trim() && user.password === loginPassword
      );

      if (matchedUser) {
        setLoggedUser(matchedUser);
        setAhuServiceName(matchedUser.company || matchedUser.username || "");
        setLoginAccepted(true);
        return;
      }

      setLoginError("Kullanıcı adı veya şifre hatalı.");
    };

    return (
      <div
        style={{
          minHeight: "100vh",
          background:
            "radial-gradient(circle at top left, rgba(37,99,235,0.08), transparent 32%), linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
          fontFamily: "SamsungSans, Arial, sans-serif",
          color: "#0f172a",
        }}
      >
        <header
          style={{
            background: "#050505",
            color: "#fff",
            borderBottom: "1px solid rgba(255,255,255,0.12)",
            boxShadow: "0 10px 28px rgba(15,23,42,0.22)",
          }}
        >
          <div
            style={{
              maxWidth: 900,
              margin: "0 auto",
              padding: "13px 18px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 14,
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 950, letterSpacing: "0.18em", opacity: 0.88 }}>
              SAMSUNG
            </div>
            <div style={{ textAlign: "center", fontWeight: 950, fontSize: 17 }}>
              AHU Onay Raporu
            </div>
            <div style={{ fontSize: 12, color: "#cbd5e1", fontWeight: 700 }}>Klima Sistemleri</div>
          </div>
        </header>

        <main style={{ maxWidth: 520, margin: "0 auto", padding: "44px 18px 48px" }}>
          <form
            onSubmit={handleLoginSubmit}
            style={{
              background: "rgba(255,255,255,0.94)",
              border: "1px solid rgba(148,163,184,0.26)",
              borderRadius: 24,
              boxShadow: "0 24px 60px rgba(15,23,42,0.12)",
              padding: 26,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                borderRadius: 999,
                padding: "7px 12px",
                background: "#eff6ff",
                border: "1px solid #bfdbfe",
                color: "#1d4ed8",
                fontWeight: 900,
                fontSize: 12,
                marginBottom: 14,
              }}
            >
              Yetkili Giriş
            </div>

            <h1 style={{ margin: 0, fontSize: 28, letterSpacing: "-0.03em", color: "#0f172a" }}>
              Kullanıcı Girişi
            </h1>

            <p style={{ margin: "8px 0 20px", color: "#64748b", fontSize: 14, fontWeight: 700 }}>
              Devam etmek için kullanıcı adı ve şifre giriniz.
            </p>

            <label style={{ display: "block", marginBottom: 14 }}>
              <span style={{ display: "block", fontWeight: 900, marginBottom: 7 }}>Kullanıcı Adı</span>
              <input
                value={loginUsername}
                onChange={(event) => setLoginUsername(event.target.value)}
                autoComplete="username"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  borderRadius: 14,
                  border: "1px solid #d1d5db",
                  padding: "13px 14px",
                  fontWeight: 800,
                  fontSize: 15,
                }}
              />
            </label>

            <label style={{ display: "block", marginBottom: 14 }}>
              <span style={{ display: "block", fontWeight: 900, marginBottom: 7 }}>Şifre</span>
              <input
                type="password"
                value={loginPassword}
                onChange={(event) => setLoginPassword(event.target.value)}
                autoComplete="current-password"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  borderRadius: 14,
                  border: "1px solid #d1d5db",
                  padding: "13px 14px",
                  fontWeight: 800,
                  fontSize: 15,
                }}
              />
            </label>

            {loginError ? (
              <div
                style={{
                  borderRadius: 14,
                  padding: "11px 12px",
                  background: "#fee2e2",
                  border: "1px solid #fecaca",
                  color: "#991b1b",
                  fontWeight: 900,
                  marginBottom: 14,
                }}
              >
                {loginError}
              </div>
            ) : null}

            <button
              type="submit"
              
              style={{
                width: "100%",
                border: 0,
                borderRadius: 16,
                padding: "15px 18px",
                background: "#0f172a",
                color: "#fff",
                fontWeight: 950,
                fontSize: 16,
                cursor: "pointer",
                boxShadow: "0 14px 28px rgba(15,23,42,0.20)",
              }}
            >
              Giriş Yap
            </button>
          </form>
        </main>
      </div>
    );
  }

  if (!approvalAccepted) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background:
            "radial-gradient(circle at top left, rgba(37,99,235,0.08), transparent 32%), linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
          fontFamily: "SamsungSans, Arial, sans-serif",
          color: "#0f172a",
        }}
      >
        <header
          style={{
            background: "#050505",
            color: "#fff",
            borderBottom: "1px solid rgba(255,255,255,0.12)",
            boxShadow: "0 10px 28px rgba(15,23,42,0.22)",
          }}
        >
          <div
            style={{
              maxWidth: 1100,
              margin: "0 auto",
              padding: "13px 18px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 14,
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 950, letterSpacing: "0.18em", opacity: 0.88 }}>
              SAMSUNG
            </div>
            <div style={{ textAlign: "center", fontWeight: 950, fontSize: 17 }}>
              AHU Onay Raporu
            </div>
            <div style={{ fontSize: 12, color: "#cbd5e1", fontWeight: 700 }}>Klima Sistemleri</div>
          </div>
        </header>

        <main style={{ maxWidth: 980, margin: "0 auto", padding: "34px 18px 48px" }}>
          <section
            style={{
              background: "rgba(255,255,255,0.92)",
              border: "1px solid rgba(148,163,184,0.26)",
              borderRadius: 24,
              boxShadow: "0 24px 60px rgba(15,23,42,0.12)",
              padding: 26,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                borderRadius: 999,
                padding: "7px 12px",
                background: "#eff6ff",
                border: "1px solid #bfdbfe",
                color: "#1d4ed8",
                fontWeight: 900,
                fontSize: 12,
                marginBottom: 14,
              }}
            >
              Samsung AHU Kontrol / Onay Süreci
            </div>

            <h1 style={{ margin: 0, fontSize: 28, letterSpacing: "-0.03em", color: "#0f172a" }}>
              Onay Beyanı
            </h1>

            <p style={{ margin: "8px 0 20px", color: "#64748b", fontSize: 14, fontWeight: 700 }}>
              Hesaplama sayfasına geçmeden önce aşağıdaki bilgilendirme ve sorumluluk beyanı onaylanmalıdır.
            </p>

            <div
              style={{
                borderRadius: 18,
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                padding: "18px 18px",
                color: "#111827",
                fontSize: 15,
                lineHeight: 1.65,
                fontWeight: 650,
                whiteSpace: "pre-line",
              }}
            >
              {APPROVAL_TEXT}
            </div>

            <label
              style={{
                marginTop: 18,
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                padding: "15px 16px",
                borderRadius: 16,
                border: `1px solid ${approvalChecked ? "#86efac" : "#cbd5e1"}`,
                background: approvalChecked ? "#f0fdf4" : "#fff",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={approvalChecked}
                onChange={(event) => setApprovalChecked(event.target.checked)}
                style={{ width: 20, height: 20, marginTop: 1, cursor: "pointer" }}
              />
              <span style={{ fontWeight: 900, color: approvalChecked ? "#166534" : "#0f172a" }}>
                Onaylıyorum. Yukarıdaki bilgilendirme ve sorumluluk beyanını okudum, kabul ediyorum.
              </span>
            </label>

            <button
              type="button"
              disabled={!approvalChecked}
              onClick={() => setApprovalAccepted(true)}
              style={{
                marginTop: 18,
                width: "100%",
                border: 0,
                borderRadius: 16,
                padding: "15px 18px",
                background: approvalChecked ? "#0f172a" : "#cbd5e1",
                color: "#fff",
                fontWeight: 950,
                fontSize: 16,
                cursor: approvalChecked ? "pointer" : "not-allowed",
                boxShadow: approvalChecked ? "0 14px 28px rgba(15,23,42,0.20)" : "none",
              }}
            >
              Hesaplama Sayfasına Geç
            </button>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(37,99,235,0.08), transparent 32%), linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
        fontFamily: "SamsungSans, Arial, sans-serif",
        color: "#0f172a",
      }}
    >
      <header
        style={{
          background: "#050505",
          color: "#fff",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          position: "sticky",
          top: 0,
          zIndex: 20,
          boxShadow: "0 10px 28px rgba(15,23,42,0.22)",
        }}
      >
        <div
          className="ahu-top-header"
          style={{
            maxWidth: 1220,
            margin: "0 auto",
            padding: "11px 18px",
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            alignItems: "center",
            gap: 16,
          }}
        >
          <div className="ahu-header-side" style={{ fontSize: 14, fontWeight: 950, letterSpacing: "0.20em", opacity: 0.92 }}>
            SAMSUNG
          </div>

          <div className="ahu-header-title" style={{ textAlign: "center", fontWeight: 950, fontSize: 17, letterSpacing: "-0.01em" }}>
            AHU Onay Raporu
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 12 }}>
            <span className="ahu-header-sub" style={{ fontSize: 14, color: "#e2e8f0", fontWeight: 900 }}>
              Klima Sistemleri
            </span>
            <button
              type="button"
              title="Kontrol kurallarını göster"
              onClick={() => setRulesInfoOpen((value) => !value)}
              style={{
                width: 34,
                height: 34,
                borderRadius: 999,
                border: "1px solid rgba(255,255,255,0.24)",
                background: "#2563eb",
                color: "#fff",
                fontWeight: 950,
                fontSize: 17,
                cursor: "pointer",
                display: "grid",
                placeItems: "center",
              }}
            >
              i
            </button>
          </div>
        </div>
      </header>

      <style>
        {`
          .ahu-main-grid {
            display: grid;
            grid-template-columns: minmax(420px, 1fr) minmax(420px, 1fr);
            gap: 18px;
            align-items: stretch;
          }
          @media (max-width: 1024px) {
            .ahu-main-grid { grid-template-columns: 1fr !important; }
            .ahu-input-column { order: 1; }
            .ahu-result-column { order: 2; }
          }
          @media (max-width: 760px) {
            .ahu-mobile-one-col { grid-template-columns: 1fr !important; }
            .ahu-battery-grid { grid-template-columns: 1fr !important; }
            .ahu-top-header {
              display: flex !important;
              align-items: center !important;
              justify-content: space-between !important;
              gap: 8px !important;
              padding: 10px 12px !important;
            }
            .ahu-header-title {
              font-size: 12px !important;
              line-height: 1.05 !important;
              text-align: center !important;
            }
            .ahu-header-side {
              font-size: 9px !important;
              letter-spacing: 0.08em !important;
            }
            .ahu-header-sub { display: none !important; }
            .ahu-header-pdf {
              padding: 7px 8px !important;
              font-size: 10px !important;
              border-radius: 9px !important;
            }
            .ahu-design-action-buttons {
              display: grid !important;
              grid-template-columns: 1fr !important;
              width: 100% !important;
              gap: 8px !important;
            }
            .ahu-design-action-button {
              width: 100% !important;
              min-height: 44px !important;
              justify-content: center !important;
              text-align: center !important;
              font-size: 13px !important;
            }
          }
        `}
      </style>

      {rulesInfoOpen ? (
        <div
          style={{
            maxWidth: 1220,
            margin: "14px auto 0",
            padding: "0 18px",
          }}
        >
          <div
            style={{
              borderRadius: 20,
              background: "#ffffff",
              border: "1px solid #cbd5e1",
              boxShadow: "0 18px 42px rgba(15,23,42,0.16)",
              padding: 16,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
              <div style={{ fontWeight: 950, color: "#0f172a", fontSize: 15 }}>Kontrol Kuralları</div>
              <button
                type="button"
                onClick={() => setRulesInfoOpen(false)}
                style={{
                  border: "1px solid #e2e8f0",
                  background: "#f8fafc",
                  borderRadius: 10,
                  padding: "5px 9px",
                  cursor: "pointer",
                  fontWeight: 950,
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                marginTop: 12,
                display: "grid",
                gap: 8,
                color: "#334155",
                fontSize: 13,
                fontWeight: 800,
                lineHeight: 1.45,
              }}
            >
              {[
                'Seçim HP kuralı: normal modda max(kW / 2,8, debi / 576). Santral Kontrol Yöntemi "0-10V" Kapasite Kontrol seçilirse santral debisi, dış ünite seçim hesabında dikkate alınmaz ve seçim kW üzerinden yapılır.',
                "Debi gösterimi: min 432, nominal 480, max 576 m³/h / HP. 480 yalnızca nominal debi konumunu gösterir.",
                "DVM S2 seçiminde devre başına maksimum 40 HP uygulanır.",
                "DVM S Eco seçiminde devre başına maksimum 10 HP uygulanır.",
                "Batarya iç hacmi: yüksek olan soğutma/ısıtma kW değeri × 0,20 ile × 0,23 arası uygun kabul edilir.",
                "EEV hesabı: standartta her 10 HP için 1 EEV yukarı yuvarlanır. 2 HP EEV Toleransı seçilirse 12 HP için 1 EEV, 22 HP için 2 EEV, 32 HP için 3 EEV uygulanabilir.",
                "Batarya giriş havası -5 / 32 °C arası uygun; 32 / 36 °C arası uyarılı uygun kabul edilir.",
                "Giriş havası 5-10 °C arasıysa dış ünite kapasitesi %10, 0-4 °C arasıysa %20, -5-0 °C arasıysa %30 artırılır.",
                "Standart dış ünite yuvarlaması: hesaplanan HP’de tam sayı kısmı çift ise alt çift HP, tek ise üst çift HP baz alınır. Örnek: 32,14 HP → 32 HP; 33,17 HP → 34 HP.",
              ].map((line, index) => (
                <div
                  key={index}
                  style={{
                    borderRadius: 12,
                    padding: "9px 11px",
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  • {line}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}

<main style={{ maxWidth: 1220, margin: "0 auto", padding: "22px 18px 40px" }}>
        <section className="ahu-main-grid">
          <div className="ahu-input-column" style={{ display: "grid", gap: 18 }}>
            <div style={{ ...cardStyle, padding: 20 }}>
            <h2 style={sectionTitleStyle}>Giriş Parametreleri</h2>
            <p style={{ margin: "6px 0 18px", color: "#64748b", fontSize: 13, fontWeight: 650 }}>
              Giriş başlıkları sabit tutuldu. Tüm zorunlu alanlar doldurulmadan rapor tamamlanamaz.
            </p>

            <div style={{ display: "grid", gap: 14 }}>
              <div
                style={{
                  marginTop: 2,
                  padding: "12px 14px",
                  borderRadius: 16,
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ fontWeight: 950, color: "#111827", fontSize: 14, marginBottom: 11 }}>
                  Proje ve Santral Bilgileri
                </div>
                <div style={{ display: "grid", gap: 12 }}>
                  {renderInput("Proje İsmi", ahuProjectName, setAhuProjectName)}
                  <div className="ahu-mobile-one-col" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
                    {renderInput("Şehir", ahuProjectCity, setAhuProjectCity)}
                    {renderInput("Santral Adı", ahuProjectDistrict, setAhuProjectDistrict, { placeholder: "KS1-KS2-HKS" })}
                  </div>
                </div>
              </div>

              <label style={{ display: "block" }}>
                <span style={labelStyle}>Samsung İş Ortağı Firma Bilgileri</span>
                <input
                  style={{
                    ...inputStyle,
                    background: "#f1f5f9",
                    color: "#334155",
                    cursor: "not-allowed",
                    fontWeight: 950,
                  }}
                  value={ahuServiceName}
                  readOnly
                  disabled
                  placeholder="Giriş yapan kullanıcıya göre otomatik gelir"
                />
                <div style={{ marginTop: 6, color: "#64748b", fontSize: 11.5, fontWeight: 800 }}>
                  Bu alan giriş yapan kullanıcıya göre otomatik atanır ve değiştirilemez.
                </div>
              </label>
              {renderInput("Tarih", ahuDate, setAhuDate, { type: "date" })}

              <label style={{ display: "block" }}>
                <span style={labelStyle}>Dış Ünite Seçimi</span>
                <select
                  style={inputStyle}
                  value={ahuOutdoorMode}
                  onChange={(event) => setAhuOutdoorMode(event.target.value)}
                >
                  <option>DVM S2</option>
                  <option>DVM S Eco</option>
                </select>
              </label>

              <label style={{ display: "block" }}>
                <span style={labelStyle}>Santral Tipi Seçimi</span>
                <select
                  style={inputStyle}
                  value={ahuAhuType}
                  onChange={(event) => setAhuAhuType(event.target.value)}
                >
                  <option>%100 Taze Havalı</option>
                  <option>Isı Geri Kazanımlı</option>
                </select>
              </label>

              <label style={{ display: "block" }}>
                <span style={labelStyle}>Santral Kontrol Yöntemi</span>
                <select
                  style={inputStyle}
                  value={ahuControlMethod}
                  onChange={(event) => setAhuControlMethod(event.target.value)}
                >
                  <option>Üfleme Sıcaklığı Kontrol</option>
                  {ahuAhuType !== "%100 Taze Havalı" ? (
                    <>
                      <option>Karışım Havası Kontrolü (Batarya Girişi)</option>
                      <option>Her İkisi de</option>
                    </>
                  ) : null}
                  <option>{CAPACITY_CONTROL_METHOD}</option>
                </select>
                {ahuAhuType === "%100 Taze Havalı" && ahuControlMethod !== CAPACITY_CONTROL_METHOD ? (
                  <div style={{ marginTop: 6, color: "#64748b", fontSize: 11.5, fontWeight: 800 }}>
                    %100 taze havalı santralde üfleme sıcaklığı kontrolü veya "0-10V" kapasite kontrol seçilebilir.
                  </div>
                ) : null}
              </label>

              {renderInput("DX Toplam Soğutma Kapasitesi (kW)", ahuCoolingCapacity, setAhuCoolingCapacity, {
                inputMode: "decimal",
              })}

              {renderInput("DX Toplam Isıtma Kapasitesi (kW)", ahuHeatingCapacity, setAhuHeatingCapacity, {
                inputMode: "decimal",
              })}
              {renderInput("Santral Debisi (m³/h)", ahuAirflow, setAhuAirflow, { inputMode: "decimal" })}

              <div className="ahu-mobile-one-col" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
                {renderInput("Evaporasyon (°C)", ahuEvapTemp, setAhuEvapTemp, { inputMode: "decimal" })}
                {renderInput("Superheat (°C)", ahuSuperheat, setAhuSuperheat, { inputMode: "decimal" })}
                {renderInput("Subcool (°C)", ahuSubcool, setAhuSubcool, { inputMode: "decimal" })}
              </div>

              <div className="ahu-mobile-one-col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {renderInput("Kondenzasyon Sıcaklığı (°C)", ahuCondTemp, setAhuCondTemp, {
                  inputMode: "decimal",
                })}
                {renderInput("Batarya İç Hacmi (L)", ahuPipeVolumeLt, setAhuPipeVolumeLt, {
                  inputMode: "decimal",
                })}
              </div>

              <div className="ahu-mobile-one-col" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
                {renderInput("Batarya Giriş Havası (°C)", ahuEnteringAirTemp, setAhuEnteringAirTemp, {
                  inputMode: "decimal",
                })}
                {renderInput("R410A Basınç Kaybı (kPa)", ahuPressureDrop, setAhuPressureDrop, {
                  inputMode: "decimal",
                })}
                {renderInput("Hava Hızı (m/s)", ahuAirVelocity, setAhuAirVelocity, {
                  inputMode: "decimal",
                })}
              </div>

              <label style={{ display: "block" }}>
                <span style={labelStyle}>DX Devre Sayısı (Akışkan boru adedi)</span>
                <select
                  style={inputStyle}
                  value={ahuCircuitCount}
                  onChange={(event) => setAhuCircuitCount(event.target.value)}
                >
                  <option>Otomatik</option>
                  <option value="1">1 Devre 2 Çıkış (1 Likit 1 Gaz)</option>
                  <option value="2">2 Devre 4 Çıkış (2 Likit 2 Gaz)</option>
                  <option value="3">3 Devre 6 Çıkış (3 Likit 3 Gaz)</option>
                  <option value="4">4 Devre 8 Çıkış (4 Likit 4 Gaz)</option>
                  <option value="5">5 Devre 10 Çıkış (5 Likit 5 Gaz)</option>
                </select>
              </label>

              <label style={{ display: "block" }}>
                <span style={labelStyle}>AHU Kart Montaj Yeri</span>
                <select
                  style={inputStyle}
                  value={ahuCardMountPlace}
                  onChange={(event) => setAhuCardMountPlace(event.target.value)}
                >
                  <option>İç Ortam</option>
                  <option>Dış Ortam</option>
                </select>
                <div style={{ marginTop: 6, color: "#64748b", fontSize: 11.5, fontWeight: 800 }}>
                  İç ortam için IP67 pano, dış ortam için IP68 pano ekipman listesine eklenir.
                </div>
              </label>

            </div>

              <div
                style={{
                  marginTop: 18,
                  paddingTop: 18,
                  paddingBottom: 2,
                  borderTop: "1px solid #e2e8f0",
                  boxSizing: "border-box",
                }}
              >
                <h2 style={sectionTitleStyle}>Batarya Seçimi</h2>
              <p style={{ margin: "6px 0 16px", color: "#64748b", fontSize: 13, fontWeight: 700 }}>
                DX batarya yerleşim tipini seçin.
              </p>
              <div className="ahu-battery-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 12 }}>
                {batteryLayouts.map((item) => {
                  const selected = batteryLayout === item.id;
                  return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => setBatteryLayout(item.id)}
                      style={{ textAlign: "left", borderRadius: 18, padding: 13, border: `2px solid ${selected ? item.border : "#e2e8f0"}`, background: selected ? item.bg : "#fff", cursor: "pointer" }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                        <div style={{ fontWeight: 950, color: "#111827", fontSize: 13 }}>{item.title}</div>
                        <span style={{ width: 15, height: 15, borderRadius: 999, border: `2px solid ${item.border}`, background: selected ? item.border : "#fff" }} />
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          height: 118,
                          borderRadius: 13,
                          border: "1px solid #e2e8f0",
                          background: "#fff",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={item.image}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </div>
                      <div style={{ marginTop: 10, display: "inline-block", borderRadius: 8, padding: "5px 9px", background: item.border, color: item.id === "parallel" ? "#111827" : "#fff", fontWeight: 950, fontSize: 11 }}>
                        {item.badge}
                      </div>
                    </button>
                  );
                })}
              </div>
              <div style={{ marginTop: 12, borderRadius: 14, padding: "11px 13px", background: selectedBatteryLayout.bg, border: `1px solid ${selectedBatteryLayout.border}`, color: selectedBatteryLayout.text, fontWeight: 800, fontSize: 13 }}>
                {selectedBatteryLayout.note}
              </div>
              <div style={{ marginTop: 16, display: "flex", justifyContent: "center" }}>
                <button
                  type="button"
                  onClick={() => setCalculationSnapshot(ahuCalc)}
                  style={{
                    border: 0,
                    borderRadius: 16,
                    padding: "15px 48px",
                    background: "#0f172a",
                    color: "#fff",
                    fontWeight: 950,
                    cursor: "pointer",
                    fontSize: 16,
                    minWidth: 240,
                    boxShadow: "0 12px 28px rgba(15,23,42,0.24)",
                  }}
                >
                  Hesapla
                </button>
              </div>
              </div>
            </div>
          </div>

          {canShowCalculation ? (
            <div className="ahu-result-column" style={{ display: "grid", width: "100%", height: "100%", boxSizing: "border-box" }}>
            <div style={{ ...cardStyle, padding: 20, width: "100%", height: "100%", boxSizing: "border-box" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 14, flexWrap: "wrap" }}>
                <h2 style={sectionTitleStyle}>Sonuçlar</h2>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                  <button
                    className="ahu-header-pdf"
                    type="button"
                    onClick={generateAhuPDF}
                    style={{
                      border: "1px solid #cbd5e1",
                      borderRadius: 14,
                      padding: "12px 16px",
                      background: "#fff",
                      color: "#0f172a",
                      fontWeight: 950,
                      cursor: "pointer",
                    }}
                  >
                    PDF Çıktısı
                  </button>

                </div>
              </div>

              {!canShowCalculation ? (
                <div style={{ marginTop: 14, borderRadius: 16, padding: "13px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", color: "#475569", fontWeight: 850 }}>
                  Girişleri doldurup Hesapla butonuna basın.
                </div>
              ) : !calc.allOk ? (
                <div style={{ marginTop: 14, borderRadius: 16, padding: "13px 14px", background: "#fee2e2", border: "1px solid #fecaca", color: "#991b1b", fontWeight: 950 }}>
                  Samsung standartlarına uygun değildir.
                  {calc.systemReason || calc.invalidRows.length > 0 ? (
                    <div style={{ marginTop: 4, fontWeight: 850 }}>
                      {calc.systemReason || `Uygun olmayan değer: ${calc.invalidRows[0].label}${calc.invalidRows.length > 1 ? ` ve ${calc.invalidRows.length - 1} madde` : ""}.`}
                    </div>
                  ) : null}
                </div>
              ) : (
                <div style={{ marginTop: 14, borderRadius: 16, padding: "13px 14px", background: "#dcfce7", border: "1px solid #86efac", color: "#166534", fontWeight: 950 }}>
                  Samsung standartlarına uygundur.
                </div>
              )}

              <div
                style={{
                  marginTop: 16,
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: 12,
                }}
              >
                {renderMetric("Hesaplanan Dış Ünite HP", displayValue(`${formatNumber(calc.requiredTotalHp)} HP`), "Kural: max(kW/2,8, debi/576)")}
                {renderMetric("Hesaplanan Dış Ünite kW", displayValue(`${formatNumber(calc.resolvedCapacityKw)} kW`), "Giriş veya hesaplanan")}
                {renderMetric(
                  "Hesaplanan Santral Debisi",
                  displayValue(`${formatNumber(calc.theoreticalAirflowM3h)} m³/h`),
                  "Seçim HP × 480 nominal debi karşılığı"
                )}
                {renderMetric(
                  "Girilen Santral Debisi",
                  displayValue(calc.hasAirflow ? `${formatNumber(toNumber(ahuAirflow))} m³/h` : calc.isCapacityControl ? "Zorunlu değil" : "Girilmedi"),
                  displayNote(calc.hasAirflow ? calc.airflowReason : calc.isCapacityControl ? "\"0-10V\" Kapasite Kontrol modunda debi zorunlu değildir." : "Debi zorunlu alan"),
                  calc.hasAirflow ? calc.activePlan?.airflowOk : calc.isCapacityControl ? true : false
                )}
                {renderMetric(
                  "Toplam Seçilen Dış Ünite",
                  displayValue(`${formatNumber(calc.totalSelectedHp)} HP / ${formatNumber(calc.totalSelectedKw)} kW`),
                  displayNote(`Toplam EEV: ${calc.totalEev}`)
                )}
                {renderMetric(
                  "İzin Verilen Santral Hava Debisi",
                  displayValue(
                    <span style={{ display: "grid", gap: 3, fontSize: 15, lineHeight: 1.25 }}>
                      <span style={{ color: calc.airflowBasisKey === "min" ? "#2563eb" : "#0f172a", fontWeight: calc.airflowBasisKey === "min" ? 950 : 800 }}>
                        <b>Min:</b> {formatNumber(calc.selectedMinAirflow)} m³/h
                      </span>
                      <span style={{ color: calc.airflowBasisKey === "nom" ? "#2563eb" : "#0f172a", fontWeight: calc.airflowBasisKey === "nom" ? 950 : 800 }}>
                        <b>Nom:</b> {formatNumber(calc.selectedStdAirflow)} m³/h
                      </span>
                      <span style={{ color: calc.airflowBasisKey === "max" ? "#2563eb" : "#0f172a", fontWeight: calc.airflowBasisKey === "max" ? 950 : 800 }}>
                        <b>Max:</b> {formatNumber(calc.selectedMaxAirflow)} m³/h
                      </span>
                    </span>
                  ),
                  displayNote(calc.airflowBasisLabel ? `Girilen debi ${calc.airflowBasisLabel} değerlendirildi.` : "Seçilen dış ünite toplam HP değerine göre izin verilen hava debisi"),
                  canShowCalculation ? calc.airflowOk : null
                )}
                {renderMetric(
                  "Ürün Bazlı Yuvarlama",
                  displayValue(`+${formatNumber(calc.roundedUpHp)} HP / +${formatNumber(calc.roundedUpKw)} kW`),
                  displayNote("Ham ihtiyaç ürün kademesine tamamlanır")
                )}
                {renderMetric(
                  "Seçim Kriteri",
                  displayValue(calc.selectionBasis.label),
                  displayNote(calc.selectionBasis.reason)
                )}
              </div>

              <div
                style={{
                  marginTop: 18,
                  paddingTop: 18,
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <h2 style={{ ...sectionTitleStyle, fontSize: 16 }}>Kontrol Sonuçları</h2>
                <div
                  style={{
                    marginTop: 12,
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                    gap: 10,
                  }}
                >
                  {calc.validationRows.map((row) => renderValidationCard(row))}
                </div>
              </div>
            </div>


          </div>
          ) : null}
        </section>

        {canShowCalculation ? (
          <section style={{ marginTop: 18, width: "100%", boxSizing: "border-box" }}>
            <div style={{ ...cardStyle, padding: 20, width: "100%", boxSizing: "border-box", fontWeight: 950 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                <h2 style={{ ...sectionTitleStyle, fontWeight: 950 }}>Tasarım Alternatifleri</h2>
                <div className="ahu-design-action-buttons" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button
                    className="ahu-design-action-button"
                    type="button"
                    disabled={!alternativeButtonsEnabled}
                    onClick={() => alternativeButtonsEnabled && setDesignPriority("minCircuit")}
                    style={{
                      borderRadius: 12,
                      border: `1px solid ${designPriority === "minCircuit" ? "#0f172a" : "#cbd5e1"}`,
                      background: designPriority === "minCircuit" ? "#0f172a" : "#fff",
                      color: designPriority === "minCircuit" ? "#fff" : "#0f172a",
                      padding: "9px 12px",
                      fontWeight: 950,
                      cursor: alternativeButtonsEnabled ? "pointer" : "not-allowed",
                      opacity: alternativeButtonsEnabled ? 1 : 0.45,
                    }}
                  >
                    1 - En Az Devre Sayısı
                  </button>
                  <button
                    className="ahu-design-action-button"
                    type="button"
                    disabled={!alternativeButtonsEnabled}
                    onClick={() => alternativeButtonsEnabled && setDesignPriority("minOutdoor")}
                    style={{
                      borderRadius: 12,
                      border: `1px solid ${designPriority === "minOutdoor" ? "#0f172a" : "#cbd5e1"}`,
                      background: designPriority === "minOutdoor" ? "#0f172a" : "#fff",
                      color: designPriority === "minOutdoor" ? "#fff" : "#0f172a",
                      padding: "9px 12px",
                      fontWeight: 950,
                      cursor: alternativeButtonsEnabled ? "pointer" : "not-allowed",
                      opacity: alternativeButtonsEnabled ? 1 : 0.45,
                    }}
                  >
                    2 - En Az Dış Ünite Sayısı
                  </button>
                  <button
                    className="ahu-design-action-button"
                    type="button"
                    disabled={!capacityBalanceButtonEnabled}
                    onClick={() => capacityBalanceButtonEnabled && setDesignPriority("closeCapacity")}
                    style={{
                      borderRadius: 12,
                      border: `1px solid ${designPriority === "closeCapacity" ? "#92400e" : "#facc15"}`,
                      background: designPriority === "closeCapacity" ? "#f59e0b" : "#fffbeb",
                      color: "#0f172a",
                      padding: "9px 12px",
                      fontWeight: 950,
                      cursor: capacityBalanceButtonEnabled ? "pointer" : "not-allowed",
                      opacity: capacityBalanceButtonEnabled ? 1 : 0.45,
                    }}
                  >
                    3 - Asimetrik Devre Tasarımı
                  </button>
                  <button
                    className="ahu-design-action-button"
                    type="button"
                    disabled={!canShowCalculation || !calc.hasEev2HpToleranceCandidate}
                    onClick={() => canShowCalculation && calc.hasEev2HpToleranceCandidate && setEev2HpToleranceActive((value) => !value)}
                    style={{
                      borderRadius: 12,
                      border: `1px solid ${eev2HpToleranceActive ? "#92400e" : "#cbd5e1"}`,
                      background: eev2HpToleranceActive ? "#f59e0b" : "#fff",
                      color: "#0f172a",
                      padding: "9px 12px",
                      fontWeight: 950,
                      cursor: canShowCalculation && calc.hasEev2HpToleranceCandidate ? "pointer" : "not-allowed",
                      opacity: canShowCalculation && calc.hasEev2HpToleranceCandidate ? 1 : 0.45,
                    }}
                  >
                    2 HP EEV Toleransı
                  </button>
                </div>
              </div>

              <div
                style={{
                  marginTop: 12,
                  borderRadius: 14,
                  padding: "10px 12px",
                  background: "#f8fafc",
                  border: "1px solid #cbd5e1",
                  color: "#0f172a",
                  fontWeight: 950,
                  fontSize: 12,
                }}
              >
                {designPriority === "minCircuit"
                  ? "Öncelik: mümkün olan en az DX devre sayısı."
                  : designPriority === "closeCapacity"
                  ? "Asimetrik Devre Tasarımı seçildi. Dış ünite dağılımı toplam seçilen HP üzerinden manuel yapılır."
                  : "Öncelik: mümkün olan en az dış ünite sayısı."}
                {eev2HpToleranceActive ? " 2 HP EEV toleransı aktiftir; EEV adedi dışında kapasite ve dış ünite hesabı değişmez." : ""}
              </div>

              {designPriority === "closeCapacity" && canShowCalculation ? (
                <div
                  style={{
                    marginTop: 12,
                    borderRadius: 16,
                    padding: "13px 14px",
                    background: "#fffbeb",
                    border: "1px solid #facc15",
                  }}
                >
                  <div style={{ fontWeight: 950, color: "#0f172a", fontSize: 13, marginBottom: 10 }}>
                    Manuel Dış Ünite Dağılımı — Toplam {formatNumber(calc.asymManualTotalHp || calc.totalSelectedHp)} HP
                  </div>
                  {calc.asymManualUnitCount > 0 ? (
                    <>
                      <label style={{ display: "block", marginBottom: 10 }}>
                        <span style={{ ...labelStyle, minHeight: 18 }}>Dış Ünite Adedi</span>
                        <select
                          style={inputStyle}
                          value={String(asymManualUnitCountOverride || calc.asymManualUnitCount || "")}
                          onChange={(event) => {
                            setAsymManualUnitCountOverride(event.target.value);
                            setAsymManualUnitValues([]);
                          }}
                        >
                          {(calc.asymManualUnitCountOptions || []).map((count) => (
                            <option key={count} value={count}>
                              {count} Adet
                            </option>
                          ))}
                        </select>
                      </label>
                      <div className="ahu-mobile-one-col" style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(calc.asymManualUnitCount, 4)}, minmax(0, 1fr))`, gap: 10 }}>
                      {Array.from({ length: calc.asymManualUnitCount }).map((_, index) => {
                        const resolvedHp = calc.asymManualResolvedUnits[index] || "";
                        const isLast = index === calc.asymManualUnitCount - 1;
                        const options = getManualUnitOptionsForIndex(
                          calc.asymManualTotalHp,
                          calc.asymManualUnitCount,
                          asymManualUnitValues.length ? asymManualUnitValues : calc.asymManualResolvedUnits,
                          index
                        );
                        const modelLabel = getModelNamesByModeAndHp("Standart", resolvedHp).join(" / ");

                        return (
                          <label key={index} style={{ display: "block" }}>
                            <span style={{ ...labelStyle, minHeight: 18 }}>Dış Ünite {index + 1}</span>
                            {isLast ? (
                              <input
                                style={{ ...inputStyle, background: "#f1f5f9", fontWeight: 950 }}
                                value={resolvedHp ? `${resolvedHp} HP` : "-"}
                                readOnly
                              />
                            ) : (
                              <select
                                style={inputStyle}
                                value={String(asymManualUnitValues[index] || resolvedHp || "")}
                                onChange={(event) => {
                                  const next = [...asymManualUnitValues];
                                  next[index] = event.target.value;
                                  next.length = calc.asymManualUnitCount - 1;
                                  setAsymManualUnitValues(next);
                                }}
                              >
                                {options.map((hp) => (
                                  <option key={hp} value={hp}>
                                    {hp} HP — {getModelNamesByModeAndHp("Standart", hp).join(" / ") || "-"}
                                  </option>
                                ))}
                              </select>
                            )}
                            <div style={{ marginTop: 5, color: "#64748b", fontSize: 11, fontWeight: 850 }}>
                              {modelLabel || "Kalan HP otomatik hesaplanır"}
                            </div>
                          </label>
                        );
                      })}
                      </div>
                    </>
                  ) : (
                    <div style={{ color: "#92400e", fontWeight: 950, fontSize: 12 }}>
                      Bu toplam HP için manuel dış ünite dağılımı oluşturulamadı.
                    </div>
                  )}
                </div>
              ) : null}

              <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
                {!canShowCalculation || calc.circuitModelGroups.length === 0 ? (
                  <div style={{ color: "#0f172a", fontWeight: 950 }}>{!canShowCalculation ? "Hesaplama başlatılmadı." : "Seçim bekleniyor."}</div>
                ) : (
                  calc.circuitModelGroups.map((circuit) => (
                    <div
                      key={circuit.circuitNo}
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                        borderRadius: 16,
                        padding: "14px 15px",
                        background: "#f8fafc",
                        border: "1px solid #cbd5e1",
                      }}
                    >
                      <div style={{ fontWeight: 950, color: "#0f172a", fontSize: 14 }}>
                        Devre {circuit.circuitNo} — {formatNumber(circuit.totalHp)} HP / {formatNumber(circuit.totalKw)} kW
                      </div>
                      <div style={{ marginTop: 8, display: "grid", gap: 5, color: "#0f172a", fontWeight: 950 }}>
                        {circuit.units.map((unit) => (
                          <div key={`${circuit.circuitNo}-${unit.unitNo}`}>
                            {unit.unitNo}. Ünite — {unit.hp} HP — {unit.models.join(" / ") || "-"}
                          </div>
                        ))}
                        <div style={{ marginTop: 6, color: "#0f172a" }}>
                          AHU Kart: {circuit.ahuKitModel} — {circuit.ahuKitQty} Adet
                        </div>
                        <div style={{ color: "#0f172a" }}>
                          EEV: {circuit.eevModel} — {circuit.eevQty} Adet
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: 14,
                  borderRadius: 16,
                  padding: "14px 15px",
                  background: "#f8fafc",
                  border: "1px solid #cbd5e1",
                }}
              >
                <div style={{ fontWeight: 950, color: "#111827", marginBottom: 8 }}>
                  Tasarım Ekipmanı
                </div>
                <div
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    borderRadius: 13,
                    padding: "11px 13px",
                    background: "#fff",
                    border: "1px solid #cbd5e1",
                    color: "#0f172a",
                    fontWeight: 950,
                    fontSize: 13,
                    lineHeight: 1.35,
                  }}
                >
                  {getRemoteControllerLine()}
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: 14,
                  borderRadius: 16,
                  padding: "14px 15px",
                  background: "#f8fafc",
                  border: "1px solid #cbd5e1",
                }}
              >
                <div style={{ fontWeight: 950, color: "#111827", marginBottom: 8 }}>
                  Gerekli Ekipman Listesi
                </div>
                <div style={{ display: "grid", gap: 8 }}>
                  {canShowCalculation ? (
                    getAccessoryLines(calc).map((line, idx) => (
                      <div
                        key={idx}
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                          borderRadius: 13,
                          padding: "11px 13px",
                          background: "#fff",
                          border: "1px solid #cbd5e1",
                          color: "#0f172a",
                          fontWeight: 950,
                          fontSize: 13,
                          lineHeight: 1.35,
                        }}
                      >
                        {line}
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        borderRadius: 13,
                        padding: "11px 12px",
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        color: "#64748b",
                        fontWeight: 900,
                        fontSize: 13,
                      }}
                    >
                      Gerekli ekipman listesi hesaplama sonrası gösterilir.
                    </div>
                  )}
                </div>
              </div>

            </div>
          </section>
        ) : null}

        <div style={{ marginTop: 18, display: "flex", justifyContent: "center" }}>
          <button
            type="button"
            onClick={generateAhuPDF}
            style={{
              width: "min(520px, 100%)",
              border: 0,
              borderRadius: 18,
              padding: "16px 22px",
              background: "#0f172a",
              color: "#fff",
              fontWeight: 950,
              fontSize: 16,
              cursor: "pointer",
              boxShadow: "0 14px 30px rgba(15,23,42,0.22)",
            }}
          >
            PDF Çıktısı Oluştur
          </button>
        </div>

      </main>
    </div>
  );
}

export default App;
